import "@rmlibrary/scroll";
import "./common";
import "./accordion";

import { generatePDF, setupPreview } from "./pdf";
import { getTextWidth, getValueFromInput, roundValuesInObject } from "./utilities";
import {
    preparePACGraphAxesOptions,
    preparePACGraphBars,
    prepareRetirementCashFlowGraphAxesOptions,
    prepareRetirementCashFlowGraphBars
} from "./logic/pac-graphing";

import $ from "jquery";
import Formatter from "@rmlibrary/formatting";
import LineGraph from "@rmlibrary/line-graph";
import { RMNumberInput } from "@rmlibrary/inputs";
import { animateRetirementGraph } from "./logic/pac-animation";
import { calculateResults } from "./logic/pac-calculations";
import { calculateVideoResults } from "./logic/pac-video-logic";
import { initPlayer } from "./pac-video";
import { retrieveFromStorage } from "./utilities";
import { storePrintValues } from "./logic/pac-storage";

const lang = document.documentElement.lang.toLowerCase().indexOf("fr") >= 0 ? "fr" : "en";
const formatter = new Formatter(lang);

const AXIS_TICK_COLOUR = "#4a4a4a";
const GRAPH_LABEL_FONT_COLOUR = "#757575";
const GRAPH_LABEL_FONT_COLOUR_PRINT = "#333333";
const DEFAULT_FONT_STRING = "Roobert";
export const drawInterval = 33.33; // 30fps
const pacGraphImage1 = $("#pac-graph0-print");
const pacGraphImage2 = $("#pac-graph1-print");
const retirementGraphImage = $("#retirement-cash-flow-graph");
const clearInputsButton = $(".btn-clear-inputs");

let showCashFlowReport = false;
let pacObject = {
    pacGraph: null,
    pacSavings: null,
    pacAnimating: false
};

let pacGraphArray = [{ ...pacObject }, { ...pacObject }];
let drawAmount = false;
let retirementCashFlowGraph = null;
let retirementSavings = null;
let retirementAnimating = false;
let inputValidity = true;
let inputValidity2 = true;
let lastResults = null;
let lastResults2 = null;
let checkboxChange = false;
let firstLoad = true;
let scenario1;
let scenario2;
let validity1;
let validity2;
let scenario1InterestRateCashflow;
let scenario2InterestRateCashflow;
let tempScenario1;
let tempScenario2;
let temScenario1 = {};
let temScenario2 = {};
let pacCheckBox = false;

export let hidePacRetirementLine = null;
export let retirementCheckboxes;

let pacStorage = {
    pacName: "",
    pacSavingsGoal: "",
    pacSavingsGoalIndefinite: "",
    pacBiWeeklyAmount: 0,
    pacBiWeeklySavings: 0,
    pacBiWeeklyExtraAmount: 0,
    pacBiWeeklyExtraSavings: 0,
    pacBiWeeklyExtraDifference: 0,
    pacMonthlyAmount: 0,
    pacMonthlySavings: 0
};

/**
 * Get the visibility status of bars in the retirement cash flow graph.
 * @return {Object}
 */
function showPacCheckBox() {
    let scenario1annualIncrease = false;
    let scenario2annualIncrease = false;

    if (
        (scenario1.annualIncreaseType === "dollar" && scenario1.annualIncreaseDollar > 0) ||
        (scenario1.annualIncreaseType === "percent" && scenario1.annualIncreasePercent > 0)
    )
        scenario1annualIncrease = true;

    if (
        scenario2 &&
        ((scenario2.annualIncreaseType === "dollar" && scenario2.annualIncreaseDollar > 0) ||
            (scenario2.annualIncreaseType === "percent" && scenario2.annualIncreasePercent > 0))
    )
        scenario2annualIncrease = true;

    if (scenario1annualIncrease || scenario2annualIncrease) {
        const isHidden = $("#pac-checkbox").is(":hidden");

        if (isHidden) {
            $(".retirement-graph-container .pac-value").show();
            $("#pac-checkbox").show();
            $('label[for="pac-checkbox"]').show();
            $("#pac-checkbox").prop("checked", true);
            pacCheckBox = true;
        }
    } else {
        const isVisible = $("#pac-checkbox").is(":visible");

        $(".retirement-graph-container .pac-value").hide();
        $("#pac-checkbox").hide();
        $('label[for="pac-checkbox"]').hide();

        if (isVisible) {
            $("#pac-checkbox").prop("checked", false);
            pacCheckBox = false;
        }
    }
}
function getBarsVisibilityStatus() {
    showPacCheckBox();
    const noPAC = getValueFromInput("#no-pac-checkbox");
    const noAnnualIncrease = getValueFromInput("#no-annual-increase-checkbox");
    const pacIsHidden = pacCheckBox;
    const pac = pacIsHidden && getValueFromInput("#pac-checkbox");
    const showAll = noPAC && noAnnualIncrease && (!pacIsHidden || pac);
    return {
        pac,
        noAnnualIncrease,
        noPAC,
        showAll
    };
}

/**
 * Get the values from all input elements.
 * @return {Object}
 */
function getInputValues() {
    const startingAmount = formatter.parseNumber(getValueFromInput("#starting-amount"));
    const contributionAmount = formatter.parseNumber(getValueFromInput("#contribution-amount"));
    const contributionFrequency = getValueFromInput("#contribution-frequency");
    const numberYears = formatter.parseNumber(getValueFromInput("#number-of-years"));
    let portfolioType = getValueFromInput("#portfolio-type");

    if (isNaN(portfolioType)) {
        portfolioType = formatter.parseNumber(getValueFromInput("#other-portfolio"));
    }

    const annualIncreasePercent = formatter.parseNumber(getValueFromInput("#annual-increase-percent"));
    const annualIncreaseDollar = formatter.parseNumber(getValueFromInput("#annual-increase-dollar"));
    const annualIncreaseType = $("input[type=radio][name=annualIncreaseType]:checked").val();

    return {
        startingAmount,
        contributionAmount,
        contributionFrequency,
        numberYears,
        portfolioType,
        annualIncreasePercent,
        annualIncreaseDollar,
        annualIncreaseType
    };
}

// setting up the input feilds to default when Add Scenario is pressed
function clearInputFields() {
    $("#starting-amount").val("0");
    $("#contribution-amount").val("0");
    $("#contribution-frequency").get(0).selectedIndex = 0;

    $("#number-of-years").val("0");
    $("#portfolio-type").get(0).selectedIndex = 1;

    $("#other-portfolio").val(0);
    $(".other-portfolio").hide();
    $("#annual-increase-percent").val("0");
    $("#annual-increase-dollar").val("0");
    $("[name=annualIncreaseType]").val(["percent"]);
    $("#annual-increase-percent").prop("disabled", false);
    $("#annual-increase-dollar").prop("disabled", true);

    $('[data-error="starting-amount"]').hide();
    $('[data-error="contribution-amount"]').hide();
    $('[data-error="number-of-years"]').hide();
    $('[data-error="other-portfolio"]').hide();
    $('[data-error="annual-increase-dollar"]').hide();
    $('[data-error="annual-increase-percent"]').hide();

    $(".pdf-pac").prop("disabled", true);
}

function getVideoInputValues() {
    const name = getValueFromInput("#name");
    const startingAmount = formatter.parseNumber(getValueFromInput("#starting-amount-video"));
    const contributionAmount = formatter.parseNumber(getValueFromInput("#contribution-amount-video"));
    const contributionIncrease = formatter.parseNumber(getValueFromInput("#annual-percentage-increase-video"));

    return {
        name,
        startingAmount,
        contributionAmount,
        contributionIncrease
    };
}

function drawPACGraph(data, canvas, printCanvas, graphNum, otherData, shouldAnimate) {
    let options, printOptions;
    let hooks, printHooks;
    const barPoints = preparePACGraphBars(data, graphNum);
    const barPointsPrint = preparePACGraphBars(data, graphNum);
    const { xAxis, yAxis } = preparePACGraphAxesOptions(data, barPoints, otherData);
    const { xAxis: xAxisPrint, yAxis: yAxisPrint } = preparePACGraphAxesOptions(data, barPointsPrint, otherData);

    const yAxis2 = {
        name: " "
    };
    const graphTop = 15;

    options = {
        misc: {
            autoResize: true,
            redrawOnWindowResize: true
        },
        xAxis,
        yAxis,
        yAxis2,
        events: {
            hoverOn: function (event, point, line) {
                const chart = $(`.pac-graph-container .chart${graphNum + 1}`);

                if (!chart.find(`.bar-overlay${graphNum}`).hasClass("transformed")) {
                    chart.find(`.info-box${graphNum}`).removeClass("transformed");

                    const clones = chart.find(`.bar-values${graphNum}`).css({ transition: "", transform: "" });

                    chart.find(`.bar-overlay${graphNum}`).removeClass("transition-settings");

                    chart.find(`.bar-values${graphNum}`).remove();
                    chart.append(clones);

                    let increase =
                        point.x - 2 >= 0 ? point.y - line.points[point.x - 2].y : point.y - data.savings.startingAmount;
                    let isIncreasePositive = true;
                    if (graphNum > 0) {
                        const keys = ["noPAC", "noAnnualIncrease", "pac"];
                        const k = keys[point.x - 1];
                        const scenario1Value = otherData.savings[k].retirement;
                        const scenario2Value = data.savings[k].retirement;
                        increase = scenario2Value - scenario1Value;

                        if (increase < 0) {
                            isIncreasePositive = false;
                        }
                    }

                    const classList = ["no-pac", "no-annual-increase", "pac"];
                    const container = $(`.${classList[point.x - 1]}${graphNum}`);

                    $(container)
                        .stop(true, false)
                        .addClass("transformed")
                        .find("[data-savings]")
                        .text(formatter.formatCurrency(point.y));

                    $(container)
                        .stop(true, false)
                        .addClass("transformed")
                        .find("[data-increase]")
                        .text(formatter.formatCurrency(Math.abs(increase)));

                    const moreOrLessStrings = {
                        more: {
                            en: "more",
                            fr: "de plus par"
                        },
                        less: {
                            en: "less",
                            fr: "de moins par"
                        }
                    };
                    const moreOrLessString = (isIncreasePositive ? moreOrLessStrings.more : moreOrLessStrings.less)[
                        lang
                    ];
                    $(container).find("[data-more-or-less]").text(moreOrLessString);

                    $(container).width(point.coords.bar.pixelWidth);
                    const containerHeight = $(container).height();
                    const containerWidth = $(container).outerWidth();

                    let top = point.coords.pixelY - containerHeight - 60;
                    const chartOffset = 0; //graphNum > 0 ? chart.outerWidth() : 0;
                    const infoBoxOffset = {
                        top: top,
                        left: point.coords.pixelX + chartOffset - containerWidth / 2
                    };

                    $(container).css({ top: infoBoxOffset.top, left: infoBoxOffset.left });

                    // Bar effect
                    const overlay = chart.find(`.bar-overlay${graphNum}`).removeAttr("style");
                    const newBarWidth = point.coords.bar.pixelWidth;
                    const newBarHeight = point.coords.bar.pixelHeight;
                    $(overlay).show().width(newBarWidth).height(newBarHeight);

                    const overlayOffset = {
                        top: point.coords.pixelY,
                        left: point.coords.pixelX + chartOffset - newBarWidth / 2
                    };

                    $(overlay).css({
                        top: overlayOffset.top,
                        left: overlayOffset.left,
                        "background-color": point.css.colour
                    });

                    setTimeout(() => {
                        $(overlay)
                            .addClass("transformed")
                            .addClass("transition-settings")
                            .attr("data-point", point.x)
                            .css({
                                transform: "translateY(-4px) translateX(-5px)",
                                width: newBarWidth + 10,
                                height: newBarHeight + 5
                            });
                    });

                    // Increase font-size
                    const valueContainer = chart.find(`[data-value='${classList[point.x - 1]}-value${graphNum}']`);

                    $(valueContainer).stop().css({
                        transition: "transform .25s ease-in-out"
                    });

                    setTimeout(() => {
                        $(valueContainer).addClass("transformed").css({
                            transform: "translateY(-10px) scale(1.3)"
                        });
                    }, 1);
                }
            },
            hoverOff: function () {
                const chart = $(`.pac-graph-container .chart${graphNum + 1}`);

                if (chart.find(`.bar-overlay${graphNum}`).hasClass("transformed")) {
                    chart.find(`.info-box${graphNum}`).removeClass("transformed");

                    chart.find(`.bar-overlay${graphNum}.transformed`).each(function () {
                        const point = $(this).attr("data-point");
                        const newHeight =
                            pacGraphArray[graphNum].pacGraph.lines[0].points[point - 1].coords.bar.pixelHeight;
                        const newWidth =
                            pacGraphArray[graphNum].pacGraph.lines[0].points[point - 1].coords.bar.pixelWidth;

                        $(this).removeClass("transformed").css({
                            transform: "translateY(0px) translateX(0px)",
                            width: newWidth,
                            height: newHeight
                        });

                        $(this).one("transitionend", () => {
                            $(this).not(".transformed").hide();
                        });
                    });

                    chart.find(`.bar-values${graphNum}.transformed`).css({
                        transform: "translateY(0px)"
                    });
                }
            }
        }
    };
    printOptions = {
        ...options,
        misc: {
            autoResize: false,
            redrawOnWindowResize: false,
            pixelRatio: 1
        },
        events: null,
        xAxis: xAxisPrint,
        yAxis: yAxisPrint,
        isPrint: true
    };

    const graphWidth = $(".pac-graph-container").width();

    let paddingSettings =
        window.innerWidth < 576
            ? {
                  graph: {
                      bottom: 30,
                      left: 0,
                      right: 0,
                      top: 20
                  },
                  edge: {
                      top: 30,
                      bottom: 50,
                      left: -25,
                      right: -25
                  }
              }
            : {
                  graph: {
                      bottom: 30,
                      left: 10,
                      right: 30,
                      top: graphTop
                  },
                  edge: {
                      top: 70,
                      bottom: 50
                  }
              };

    const styles = {
        xAxis: {
            title: {
                size: graphWidth < 300 ? "16px" : "20px",
                font: DEFAULT_FONT_STRING,
                colour: GRAPH_LABEL_FONT_COLOUR
            }
        },
        border: {
            colour: {
                bottom: AXIS_TICK_COLOUR,
                left: "rgba(0, 0, 0, 0)" // Hides y-axis
            },
            width: {
                bottom: 1,
                left: 1
            }
        },
        padding: paddingSettings
    };
    const printStyles = {
        ...styles,
        xAxis: {
            ...styles.xAxis,
            title: {
                ...styles.xAxis.title,
                colour: GRAPH_LABEL_FONT_COLOUR_PRINT
            }
        },
        padding: {
            ...styles.padding,
            edge: {
                ...styles.padding.edge,
                bottom: 70
            }
        }
    };

    hooks = {
        drawCallback: function () {
            const chart = $(`.pac-graph-container .chart${graphNum + 1}`);

            chart.find(`.bar-overlay${graphNum}`).hide();
            $(".info-box" + graphNum).removeClass("transformed");
            if (!pacGraphArray[graphNum].pacAnimating && inputValidity && inputValidity2) {
                drawPacAmounts(this, graphNum);
            } else {
                chart.find(`.bar-values${graphNum}`).fadeOut();
            }
        },
        drawTable: function (tableDiv) {
            tableDiv = typeof tableDiv === "string" ? document.querySelector(tableDiv) : tableDiv;

            if (!tableDiv) {
                throw "LineGraph.drawTable - must provide HTML element/selector as argument";
            }

            var table = document.createElement("table"),
                row,
                cellEl,
                cell = "th";

            this.table[1][1] = data.savings.noPAC.retirement;
            this.table[2][1] = data.savings.noAnnualIncrease.retirement;
            this.table[3][1] = data.savings.pac.retirement;

            const newTable = this.table.map((tableRow, i) => {
                let newTableRow = [...tableRow];
                if (i !== 0) {
                    newTableRow[0] = data.savings.legend[i - 1].replace(/\/space\//g, " ").replace(/\n/g, "");
                    newTableRow[1] = formatter.formatCurrency(tableRow[1]);
                } else {
                    newTableRow[1] = lang === "en" ? "Savings" : "Épargne";
                }
                return newTableRow;
            });

            for (var x = 0, len = newTable.length; x < len; x++) {
                row = document.createElement("tr");
                for (var y = 0, lenY = newTable[x].length; y < lenY; y++) {
                    cellEl = document.createElement(cell);
                    cellEl.innerHTML = newTable[x][y];
                    row.appendChild(cellEl);
                }
                cell = "td";
                table.appendChild(row);
            }

            $(tableDiv).empty().append(table);
        }
    };
    printHooks = {
        drawCallback: function () {
            drawPacAmountsPrint(this, graphNum);
        },
        drawTitles: hooks.drawTitles
    };

    if (!pacGraphArray[graphNum].printGraph) {
        if (graphNum === 0) {
            document.getElementById("pac-graph0-print").width = scenario2 ? 400 : 1000;
        }
        pacGraphArray[graphNum].printGraph = new LineGraph(printCanvas, printOptions, printStyles, printHooks);
        const pacSavings = preparePACGraphBars(data, graphNum).savings;
        pacGraphArray[graphNum].printGraph.addLine(pacSavings);
        pacGraphArray[graphNum].printGraph.draw();
    } else {
        if (graphNum === 0) {
            document.getElementById("pac-graph0-print").width = scenario2 ? 400 : 1000;
        }
        pacGraphArray[graphNum].printGraph.clearLines();
        pacGraphArray[graphNum].printGraph.setOptions(printOptions);
        const pacSavings = preparePACGraphBars(data, graphNum).savings;
        pacGraphArray[graphNum].printGraph.addLine(pacSavings);
        pacGraphArray[graphNum].printGraph.draw();
    }

    const axes = {
        xAxis: options.xAxis,
        yAxis: options.yAxis
    };

    if (!pacGraphArray[graphNum].pacGraph) {
        const oldData = calculateResults({
            startingAmount: 0,
            contributionAmount: 0,
            contributionFrequency: "weekly",
            numberYears: 1,
            portfolioType: 5,
            annualIncreasePercent: 0,
            annualIncreaseDollar: 0,
            annualIncreaseType: "percent"
        });
        const oldPacSavings = preparePACGraphBars(oldData, graphNum).savings;
        pacGraphArray[graphNum].pacSavings = preparePACGraphBars(data, graphNum).savings;
        pacGraphArray[graphNum].pacGraph = new LineGraph(canvas, options, styles, hooks);

        pacGraphArray[graphNum].pacGraph.addLine(oldPacSavings);
        pacGraphArray[graphNum].pacGraph.draw();
        animateGraph(oldPacSavings, pacGraphArray[graphNum].pacSavings, options, styles, hooks, graphNum);
        pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);
    } else if (inputValidity && inputValidity2) {
        const newPacSavings = preparePACGraphBars(data, graphNum).savings;
        newPacSavings.id = 0;
        const oldYValues = [
            pacGraphArray[graphNum].pacSavings.points[0].y,
            pacGraphArray[graphNum].pacSavings.points[1].y,
            pacGraphArray[graphNum].pacSavings.points[2].y,
            Math.max(
                pacGraphArray[graphNum].pacSavings.points[2].y,
                pacGraphArray[(graphNum + 1) % 2].pacSavings
                    ? pacGraphArray[(graphNum + 1) % 2].pacSavings.points[2].y
                    : 0
            )
        ];
        const newYValues = [
            newPacSavings.points[0].y,
            newPacSavings.points[1].y,
            newPacSavings.points[2].y,
            Math.max(data.savings.pac.retirement, otherData ? otherData.savings.pac.retirement : 0)
        ];
        const hasSameYValues = newYValues.every((value, index) => value === oldYValues[index]);
        if (hasSameYValues) {
            pacGraphArray[graphNum].pacGraph.setOptions(axes, styles, hooks);
            pacGraphArray[graphNum].pacGraph.draw();
            pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);
        } else {
            animateGraph(pacGraphArray[graphNum].pacSavings, newPacSavings, options, styles, hooks, graphNum);
        }
    } else {
        pacGraphArray[graphNum].pacGraph.clearLines();
        pacGraphArray[graphNum].pacGraph.setOptions(axes, styles, hooks);
        pacGraphArray[graphNum].pacGraph.draw();
        pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);
    }
}

function animateGraph(oldData, newData, newOptions, newStyles, newHooks, graphNum) {
    if (oldData.points[2].y >= newData.points[2].y) {
        animatePacGraphDown(oldData, newData, newOptions, newStyles, newHooks, graphNum);
    } else {
        animatePacGraphUp(oldData, newData, newOptions, newStyles, newHooks, graphNum);
    }
}

function animatePacGraphUp(oldData, newData, newOptions, newStyles, newHooks, graphNum) {
    pacGraphArray[graphNum].pacAnimating = true;
    let oldY = pacGraphArray[graphNum].pacGraph.options.yAxis.range[1];
    const newY = newOptions.yAxis.range[1];
    const increment = ((newY - oldY) / drawInterval) * 2.5;

    const animateUp = setInterval(function () {
        if (oldY >= newY) {
            clearInterval(animateUp);
            $("pac-graph" + graphNum).off();
            pacGraphArray[graphNum].pacGraph.setOptions(newOptions, newStyles, newHooks);
            pacGraphArray[graphNum].pacGraph.draw();
            pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);

            animateBarsUp(oldData, newData, newOptions, newStyles, newHooks, graphNum);
        } else {
            let tempOptions = newOptions;
            tempOptions.yAxis.range = [0, oldY];
            oldY += increment;
            pacGraphArray[graphNum].pacGraph.setOptions(tempOptions, newStyles, newHooks);
            pacGraphArray[graphNum].pacGraph.draw();
            pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);
        }
    }, drawInterval);
}

function animateBarsUp(oldData, newData, newOptions, newStyles, newHooks, graphNum) {
    const oldY = {
        noPac: oldData.points[0].y,
        noIncrease: oldData.points[1].y,
        pac: oldData.points[2].y
    };

    const newY = {
        noPac: newData.points[0].y,
        noIncrease: newData.points[1].y,
        pac: newData.points[2].y
    };

    const increments = {
        noPac: ((newY.noPac - oldY.noPac) / drawInterval) * 2.5,
        noIncrease: ((newY.noIncrease - oldY.noIncrease) / drawInterval) * 2.5,
        pac: ((newY.pac - oldY.pac) / drawInterval) * 2.5
    };

    const animateUp = setInterval(function () {
        if (oldY.pac >= newY.pac) {
            clearInterval(animateUp);
            pacGraphArray[graphNum].pacAnimating = false;

            const tempData = oldData;
            tempData.points[0].y = newY.noPac;
            tempData.points[1].y = newY.noIncrease;
            tempData.points[2].y = newY.pac;

            firstLoad = false;
            pacGraphArray[graphNum].pacGraph.clearLines();
            pacGraphArray[graphNum].pacGraph.addLine(newData);
            pacGraphArray[graphNum].pacGraph.setOptions(newOptions, newStyles, newHooks);
            pacGraphArray[graphNum].pacGraph.draw();
            pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);
        } else {
            const tempData = oldData;

            tempData.points[0].y = oldY.noPac;
            tempData.points[1].y = oldY.noIncrease;
            tempData.points[2].y = oldY.pac;

            oldY.noPac += increments.noPac;
            oldY.noIncrease += increments.noIncrease;
            oldY.pac += increments.pac;

            pacGraphArray[graphNum].pacGraph.clearLines();
            pacGraphArray[graphNum].pacGraph.addLine(tempData);
            pacGraphArray[graphNum].pacGraph.setOptions(newOptions, newStyles, newHooks);
            pacGraphArray[graphNum].pacGraph.draw();
            pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);
        }
    }, drawInterval);
}

function animatePacGraphDown(oldData, newData, newOptions, newStyles, newHooks, graphNum) {
    const oldY = {
        noPac: oldData.points[0].y,
        noIncrease: oldData.points[1].y,
        pac: oldData.points[2].y
    };

    const newY = {
        noPac: newData.points[0].y,
        noIncrease: newData.points[1].y,
        pac: newData.points[2].y
    };

    const increments = {
        noPac: ((oldY.noPac - newY.noPac) / drawInterval) * 2.5,
        noIncrease: ((oldY.noIncrease - newY.noIncrease) / drawInterval) * 2.5,
        pac: ((oldY.pac - newY.pac) / drawInterval) * 2.5
    };

    const animateDown = setInterval(function () {
        if (oldY.pac <= newY.pac) {
            clearInterval(animateDown);

            const tempData = oldData;
            tempData.points[0].y = newY.noPac;
            tempData.points[1].y = newY.noIncrease;
            tempData.points[2].y = newY.pac;

            pacGraphArray[graphNum].pacGraph.clearLines();
            pacGraphArray[graphNum].pacGraph.addLine(newData);
            pacGraphArray[graphNum].pacGraph.setOptions(newOptions, newStyles, newHooks);
            pacGraphArray[graphNum].pacGraph.draw();
            pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);

            animateYAxisDown(newData, newOptions, newStyles, newHooks, graphNum);
        } else {
            const tempData = oldData;

            tempData.points[0].y = oldY.noPac;
            tempData.points[1].y = oldY.noIncrease;
            tempData.points[2].y = oldY.pac;

            oldY.noPac -= increments.noPac;
            oldY.noIncrease -= increments.noIncrease;
            oldY.pac -= increments.pac;

            pacGraphArray[graphNum].pacGraph.clearLines();
            pacGraphArray[graphNum].pacGraph.addLine(tempData);
            pacGraphArray[graphNum].pacGraph.setOptions(newOptions, newStyles, newHooks);
            pacGraphArray[graphNum].pacGraph.draw();
            pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);
        }
    }, drawInterval);
}

function animateYAxisDown(newData, newOptions, newStyles, newHooks, graphNum) {
    let oldY = pacGraphArray[graphNum].pacGraph.options.yAxis.range[1];
    const newY = newOptions.yAxis.range[1];
    const increment = ((oldY - newY) / drawInterval) * 2.5;

    const animateUp = setInterval(function () {
        if (oldY <= newY) {
            clearInterval(animateUp);
            pacGraphArray[graphNum].pacAnimating = false;
            let tempOptions = newOptions;
            tempOptions.yAxis.range = [0, newY];
            pacGraphArray[graphNum].pacGraph.setOptions(tempOptions, newStyles, newHooks);
            pacGraphArray[graphNum].pacGraph.draw();
            pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);
            pacGraphArray[graphNum].pacSavings = newData;
        } else {
            let tempOptions = newOptions;
            tempOptions.yAxis.range = [0, oldY];
            oldY -= increment;
            pacGraphArray[graphNum].pacGraph.setOptions(tempOptions, newStyles, newHooks);
            pacGraphArray[graphNum].pacGraph.draw();
            pacGraphArray[graphNum].pacGraph.drawTable(".pac-graph-container > #table-pacgraph" + graphNum);
        }
    }, drawInterval);
}

function drawRetirementCashFlowGraph(data, scenario) {
    const { xAxis, yAxis } = prepareRetirementCashFlowGraphAxesOptions(data);
    const options = {
        misc: {
            autoResize: true,
            redrawOnWindowResize: true
        },
        xAxis,
        yAxis,
        events: {
            hoverOn: function (event, point) {
                const retirementGraphContainer = $(".retirement-graph-container");

                if (
                    !retirementGraphContainer.find(".pac-plus-overlay").hasClass("transformed") &&
                    !retirementGraphContainer.find(".no-annual-increase-overlay").hasClass("transformed") &&
                    !retirementGraphContainer.find(".no-pac-overlay").hasClass("transformed")
                ) {
                    const pointIndex = point.coords.index;
                    const graphWidth = retirementGraphContainer.outerWidth();
                    const graphType = graphWidth <= 450 ? "small" : "large";

                    // Bar growth effect
                    const pacPlusOverlay = retirementGraphContainer
                        .find(".pac-plus-overlay")
                        .removeAttr("style")
                        .attr("data-point-index", pointIndex)
                        .removeClass("transition-settings");
                    const noAnnualIncreaseOverlay = retirementGraphContainer
                        .find(".no-annual-increase-overlay")
                        .removeAttr("style")
                        .attr("data-point-index", pointIndex)
                        .removeClass("transition-settings");
                    const noPacOverlay = retirementGraphContainer
                        .find(".no-pac-overlay")
                        .removeAttr("style")
                        .attr("data-point-index", pointIndex)
                        .removeClass("transition-settings");

                    const pacPlusHeight =
                        retirementCashFlowGraph.lines[0].points[pointIndex].coords.bar.pixelHeight -
                        retirementCashFlowGraph.lines[1].points[pointIndex].coords.bar.pixelHeight +
                        1;
                    const noAnnualIncreaseHeight =
                        retirementCashFlowGraph.lines[1].points[pointIndex].coords.bar.pixelHeight -
                        retirementCashFlowGraph.lines[2].points[pointIndex].coords.bar.pixelHeight +
                        1;
                    const noPacHeight = retirementCashFlowGraph.lines[2].points[pointIndex].coords.bar.pixelHeight + 1;

                    const pixelWidth = point.coords.bar.pixelWidth;

                    $(pacPlusOverlay).show().width(pixelWidth).height(pacPlusHeight).addClass("transformed");
                    $(noAnnualIncreaseOverlay)
                        .show()
                        .width(pixelWidth)
                        .height(noAnnualIncreaseHeight)
                        .addClass("transformed");
                    $(noPacOverlay).show().width(pixelWidth).height(noPacHeight).addClass("transformed");

                    const pacPlusOverlayOffset = {
                        top: retirementCashFlowGraph.lines[0].points[pointIndex].coords.pixelY,
                        left: point.coords.pixelX - pixelWidth / 2
                    };
                    const noAnnualIncreaseOverlayOffset = {
                        top: retirementCashFlowGraph.lines[1].points[pointIndex].coords.pixelY,
                        left: point.coords.pixelX - pixelWidth / 2
                    };
                    const noPacOverlayOffset = {
                        top: retirementCashFlowGraph.lines[2].points[pointIndex].coords.pixelY,
                        left: point.coords.pixelX - pixelWidth / 2
                    };

                    const pacColour = retirementCashFlowGraph.lines[0].points[pointIndex].coords.colour;
                    const noAnnualIncreaseColour = retirementCashFlowGraph.lines[1].points[pointIndex].coords.colour;
                    const noPACColour = retirementCashFlowGraph.lines[2].points[pointIndex].coords.colour;

                    $(pacPlusOverlay).css({
                        top: pacPlusOverlayOffset.top,
                        left: pacPlusOverlayOffset.left,
                        background: pacColour
                    });

                    $(noAnnualIncreaseOverlay).css({
                        top: noAnnualIncreaseOverlayOffset.top,
                        left: noAnnualIncreaseOverlayOffset.left,
                        background: noAnnualIncreaseColour
                    });

                    $(noPacOverlay).css({
                        top: noPacOverlayOffset.top,
                        left: noPacOverlayOffset.left,
                        background: noPACColour
                    });

                    setTimeout(() => {
                        $(pacPlusOverlay).addClass("transition-settings").css({
                            transform: "scaleX(1.1)"
                        });

                        $(noAnnualIncreaseOverlay).addClass("transition-settings").css({
                            transform: "scaleX(1.1)"
                        });

                        $(noPacOverlay).addClass("transition-settings").css({
                            transform: "scaleX(1.1)"
                        });
                    }, 1);

                    // Increase font-size
                    const maxYValue = retirementCashFlowGraph.lines.reduce((maxValue, line) => {
                        const yValues = line.points.map((point) => point.y);
                        return Math.max(maxValue, ...yValues);
                    }, retirementCashFlowGraph.lines[0].points[0].y);
                    const formattedMaxYValue = formatter.formatCurrency(maxYValue, 0);
                    const styles =
                        graphWidth <= 450
                            ? {
                                  fontSize: 12,
                                  fontWeight: "normal"
                              }
                            : {
                                  fontSize: 14,
                                  fontWeight: "bold"
                              };
                    const maxYValueTextWidth = Math.ceil(
                        getTextWidth(
                            `• ${formattedMaxYValue}`,
                            `${styles.fontWeight} ${styles.fontSize * 0.75}pt Roobert`
                        )
                    );
                    const valuesWidth = graphType === "small" ? maxYValueTextWidth + 20 : 120;

                    const clones = $(".retirement-values").css({
                        transition: "",
                        transform: "",
                        width: valuesWidth
                    });
                    $(".retirement-values").remove();

                    retirementGraphContainer.append(clones);

                    const container = retirementGraphContainer.find('[data-point="' + pointIndex + '"]');

                    $(container).css({
                        transition: "transform .25s ease-in-out, width .25s ease-in-out"
                    });

                    setTimeout(() => {
                        $(container).css({
                            transform: "translateX(-5px) translateY(-10px) scale(1.3)",
                            width: valuesWidth
                        });
                    });
                }
            },
            hoverOff: function () {
                const retirementGraphContainer = $(".retirement-graph-container");

                if (
                    retirementGraphContainer.find(".pac-plus-overlay").hasClass("transformed") &&
                    retirementGraphContainer.find(".no-annual-increase-overlay").hasClass("transformed") &&
                    retirementGraphContainer.find(".no-pac-overlay").hasClass("transformed")
                ) {
                    const graphWidth = retirementGraphContainer.outerWidth();
                    const graphType = graphWidth <= 450 ? "small" : "large";

                    const pacPlusOverlay = retirementGraphContainer.find(".pac-plus-overlay");
                    const noAnnualIncreaseOverlay = retirementGraphContainer.find(".no-annual-increase-overlay");
                    const noPacOverlay = retirementGraphContainer.find(".no-pac-overlay");

                    const pointIndex = $(pacPlusOverlay).attr("data-point-index");

                    if (!isNaN(pointIndex)) {
                        const pacPlusHeight =
                            retirementCashFlowGraph.lines[0].points[pointIndex].coords.bar.pixelHeight -
                            retirementCashFlowGraph.lines[1].points[pointIndex].coords.bar.pixelHeight;
                        const noAnnualIncreaseHeight =
                            retirementCashFlowGraph.lines[1].points[pointIndex].coords.bar.pixelHeight -
                            retirementCashFlowGraph.lines[2].points[pointIndex].coords.bar.pixelHeight;
                        const noPacHeight = retirementCashFlowGraph.lines[2].points[pointIndex].coords.bar.pixelHeight;

                        const pixelWidth = retirementCashFlowGraph.lines[2].points[pointIndex].coords.bar.pixelWidth;

                        $(pacPlusOverlay).removeClass("transformed").css({
                            transform: "translateX(0px) translateY(0px)",
                            width: pixelWidth,
                            height: pacPlusHeight
                        });

                        $(noAnnualIncreaseOverlay).removeClass("transformed").css({
                            transform: "translateX(0px) translateY(0px)",
                            width: pixelWidth,
                            height: noAnnualIncreaseHeight
                        });

                        $(noPacOverlay).removeClass("transformed").css({
                            transform: "translateX(0px) translateY(0px)",
                            width: pixelWidth,
                            height: noPacHeight
                        });

                        $(pacPlusOverlay).one("transitionend", () => {
                            $(pacPlusOverlay).not(".transformed").hide();
                        });

                        $(noAnnualIncreaseOverlay).one("transitionend", () => {
                            $(noAnnualIncreaseOverlay).not(".transformed").hide();
                        });

                        $(noPacOverlay).one("transitionend", () => {
                            $(noPacOverlay).not(".transformed").hide();
                        });

                        const maxYValue = retirementCashFlowGraph.lines.reduce((maxValue, line) => {
                            const yValues = line.points.map((point) => point.y);
                            return Math.max(maxValue, ...yValues);
                        }, retirementCashFlowGraph.lines[0].points[0].y);
                        const formattedMaxYValue = formatter.formatCurrency(maxYValue, 0);
                        const styles =
                            graphWidth <= 450
                                ? {
                                      fontSize: 12,
                                      fontWeight: "normal"
                                  }
                                : {
                                      fontSize: 14,
                                      fontWeight: "bold"
                                  };
                        const maxYValueTextWidth = Math.ceil(
                            getTextWidth(
                                `• ${formattedMaxYValue}`,
                                `${styles.fontWeight} ${styles.fontSize * 0.75}pt Roobert`
                            )
                        );
                        const valuesWidth = graphType === "small" ? maxYValueTextWidth + 20 : 120;

                        $('[data-point="' + pointIndex + '"]').css({
                            transform: "translateX(0px) translateY(0px)",
                            width: valuesWidth
                        });
                    }
                }
            }
        }
    };

    const graphWidth = $(".retirement-graph-container").outerWidth();

    const styles = {
        border: {
            colour: {
                bottom: AXIS_TICK_COLOUR,
                left: AXIS_TICK_COLOUR
            },
            width: {
                bottom: 1,
                left: 1
            }
        },
        padding: {
            graph: {
                bottom: 10,
                left: 10,
                right: 10,
                top: 15
            },
            edge: {
                bottom: 5,
                left: 10,
                right: 10
            }
        }
    };
    const hooks = {
        drawCallback: function () {
            const styleSheet =
                graphWidth <= 450
                    ? {
                          "font-size": "12px",
                          "font-weight": "normal"
                      }
                    : {
                          "font-size": "14px",
                          "font-weight": "bold"
                      };
            $(".retirement-data").css(styleSheet);
            $(".retirement-values").hide();

            if (!retirementAnimating && inputValidity) {
                drawRetirementAmounts(this, scenario);
            }

            $(".retirement-graph-container")
                .find(".bar-overlay, .retirement-overlay")
                .each(function () {
                    $(this).hide();
                });
        },
        drawTable: function (tableDiv) {
            tableDiv = typeof tableDiv === "string" ? document.querySelector(tableDiv) : tableDiv;

            if (!tableDiv) {
                throw "LineGraph.drawTable - must provide HTML element/selector as argument";
            }
            const table = document.createElement("table");
            let row;
            let cellEl;
            let cell = "th";
            const newTable = this.table.map((tableRow, i) => {
                let newTableRow = [...tableRow];
                if (i === 0) {
                    newTableRow[0] = lang === "en" ? "Number of years" : "Nombre d'années";
                    for (let j = 1; j < 4; j++) {
                        newTableRow[j] = data.withdrawals.legend[2 - (j - 1)]
                            .replace(/\/space\//g, " ")
                            .replace(/\n/g, "");
                    }
                } else {
                    for (let j = 1; j < 4; j++) {
                        newTableRow[j] = formatter.formatCurrency(tableRow[j]);
                    }
                }
                return newTableRow;
            });

            for (let x = 0, len = newTable.length; x < len; x++) {
                row = document.createElement("tr");
                for (let y = 0, lenY = newTable[x].length; y < lenY; y++) {
                    cellEl = document.createElement(cell);

                    if (y == 0 & x != 0) {
                        cellEl.innerHTML = `${newTable[x][y]} years`;
                    } else {
                        cellEl.innerHTML = newTable[x][y];
                    }
                    row.appendChild(cellEl);
                }
                cell = "td";
                table.appendChild(row);
            }

            $(tableDiv).empty().append(table);
        }
    };
    if (!retirementCashFlowGraph) {
        retirementCashFlowGraph = new LineGraph("#retirement-cash-flow-graph", options, styles, hooks);

        const barsVisibilityStatus = getBarsVisibilityStatus();
        retirementSavings = prepareRetirementCashFlowGraphBars({
            barsVisibilityStatus,
            data,
            scenario
        });

        retirementSavings.pac.id = 0;
        retirementSavings.noAnnualIncrease.id = 1;
        retirementSavings.noPAC.id = 2;

        retirementCashFlowGraph.addLine(retirementSavings.pac);
        retirementCashFlowGraph.addLine(retirementSavings.noAnnualIncrease);
        retirementCashFlowGraph.addLine(retirementSavings.noPAC);
        retirementCheckboxes = barsVisibilityStatus;
    }
    if (inputValidity) {
        const barsVisibilityStatus = getBarsVisibilityStatus();
        retirementSavings = prepareRetirementCashFlowGraphBars({
            barsVisibilityStatus,
            data,
            scenario
        });

        const options = {
            axes: {
                xAxis,
                yAxis
            },
            styles,
            hooks
        };

        if (checkboxChange) {
            animateRetirementGraph(
                retirementCashFlowGraph,
                retirementCheckboxes,
                barsVisibilityStatus,
                retirementSavings,
                options
            );

            checkboxChange = false;
        } else {
            retirementCashFlowGraph.clearLines();
            retirementCashFlowGraph.addLine(retirementSavings.pac);
            retirementCashFlowGraph.addLine(retirementSavings.noAnnualIncrease);
            retirementCashFlowGraph.addLine(retirementSavings.noPAC);
            retirementCashFlowGraph.setOptions(options.axes, styles, hooks);
            retirementCashFlowGraph.draw();
        }
    } else {
        retirementCashFlowGraph.clearLines();
    }

    retirementCashFlowGraph.drawTable(".retirement-graph-container > .table");
}

function drawPacAmounts(graph, graphNum) {
    let ctx = graph.canvas.getContext("2d");

    const classList = [`no-pac-value${graphNum}`, `no-annual-increase-value${graphNum}`, `pac-value${graphNum}`];

    const chart = $(`.pac-graph-container .chart${graphNum + 1}`);
    chart.find(".generated").remove();

    graph.lines[0].points.forEach((point, index) => {
        if ((point.y !== undefined || point.y !== null) && !firstLoad) {
            const barValue = chart
                .find(`.bar-value-base${graphNum}`)
                .clone()
                .removeClass(`bar-value-base${graphNum}`)
                .addClass("generated")
                .attr("data-value", classList[index]);
            const barData = formatter.formatCurrency(point.y, 0);

            let fontSize = 18;
            if (window.innerWidth < 576) {
                fontSize = 14;
            }
            if (barData.length > 8) {
                fontSize -= 3;
            }

            $(barValue).css({ "font-size": fontSize }).find(".bar-data").addClass(classList[index]).text(barData);

            chart.append(barValue);
            if (!drawAmount) {
                $(barValue).show();
            }
            const barValueHeight = $(barValue).height();
            const barValueWidth = $(barValue).outerWidth();

            const chartOffset = 0; //graphNum > 0 ? $(".pac-graph-container .chart1").outerWidth() : 0;
            const offset = {
                top: point.coords.pixelY - barValueHeight - 10,
                left: point.coords.pixelX + chartOffset - barValueWidth / 2
            };

            $(barValue).css({ top: offset.top, left: offset.left });
            if (drawAmount) {
                ctx.save();
                ctx.textAlign = "center";
                ctx.font = `16px ${DEFAULT_FONT_STRING}`;
                ctx.fillStyle = "#000000";
                ctx.baseline = "top";
                ctx.fillText(barData, offset.left + barValueWidth / 2 - chartOffset, offset.top);
                ctx.restore();
            }
        }
    });
}

function drawPacAmountsPrint(graph) {
    const graphPoints = graph.lines[0].points;
    let ctx = graph.canvas.getContext("2d");

    if (!graph.lines[0]) {
        return;
    }

    graphPoints.forEach((point, index) => {
        const barData = formatter.formatCurrency(point.y, 0);

        const offset = {
            top: point.coords.pixelY - 26,
            left: point.coords.pixelX
        };

        if (
            pacGraphArray.length > 1 &&
            graphPoints[1].y === graphPoints[2].y &&
            formatter.formatCurrency(graphPoints[2].y, 0).length > 7 &&
            index === 2
        ) {
            offset.top = point.coords.pixelY - 46;
        }

        ctx.save();
        ctx.textAlign = "center";
        ctx.font = `16px ${DEFAULT_FONT_STRING}`;
        ctx.fillStyle = "#000000";
        ctx.baseline = "top";
        ctx.fillText(barData, offset.left, offset.top);
        ctx.restore();
    });
}

function drawRetirementAmounts(graph, scenario) {
    const lines = {
        "pac-value": graph.lines[0].points,
        "no-annual-increase-value": graph.lines[1].points,
        "no-pac-value": graph.lines[2].points
    };

    retirementCheckboxes = getBarsVisibilityStatus();

    let category;
    if (
        (!retirementCheckboxes.pac || hidePacRetirementLine) &&
        !retirementCheckboxes.noAnnualIncrease &&
        retirementCheckboxes.noPAC
    ) {
        category = "no-pac-value";
    } else if ((!retirementCheckboxes.pac || hidePacRetirementLine) && retirementCheckboxes.noAnnualIncrease) {
        category = "no-annual-increase-value";
    } else if (retirementCheckboxes.pac) {
        category = "pac-value";
    } else {
        category = "no-values";
    }

    for (let line in lines) {
        lines[line].forEach((point, index) => {
            if (point.y !== undefined || point.y !== null) {
                const container = $('.bar-values[data-point="' + index + '"]');
                const graphData = formatter.formatCurrency(point.y, 0);
                $(container)
                    .find("." + line)
                    .text(graphData);

                if (retirementCheckboxes.pac) {
                    if (scenario == "scenario1") {
                        $(container).find(".pac-value").show().addClass("pac-value-scenario1");
                        $(container).find(".pac-value").removeClass("pac-value-scenario2");
                    } else {
                        $(container).find(".pac-value").show().addClass("pac-value-scenario2");
                        $(container).find(".pac-value").removeClass("pac-value-scenario1");
                    }
                } else $(container).find(".pac-value").hide();

                if (retirementCheckboxes.noAnnualIncrease) {
                    if (scenario == "scenario1") {
                        $(container)
                            .find(".no-annual-increase-value")
                            .show()
                            .addClass("no-annual-increase-value-scenario1");
                        $(container)
                            .find(".no-annual-increase-value")
                            .removeClass("no-annual-increase-value-scenario2");
                    } else {
                        $(container)
                            .find(".no-annual-increase-value")
                            .show()
                            .addClass("no-annual-increase-value-scenario2");
                        $(container)
                            .find(".no-annual-increase-value")
                            .removeClass("no-annual-increase-value-scenario1");
                    }
                } else $(container).find(".no-annual-increase-value").hide();

                if (retirementCheckboxes.noPAC) {
                    if (scenario == "scenario1") {
                        $(container).find(".no-pac-value").show().addClass("no-pac-value-scenario1");
                        $(container).find(".no-pac-value").removeClass("no-pac-value-scenario2");
                    } else {
                        $(container).find(".no-pac-value").show().addClass("no-pac-value-scenario2");
                        $(container).find(".no-pac-value").removeClass("no-pac-value-scenario1");
                    }
                } else $(container).find(".no-pac-value").hide();
            }
        });

        const graphWidth = $(".retirement-graph-container").outerWidth();
        const maxYValue = graph.lines.reduce((maxValue, line) => {
            const yValues = line.points.map((point) => point.y);
            return Math.max(maxValue, ...yValues);
        }, graph.lines[0].points[0].y);
        const formattedMaxYValue = formatter.formatCurrency(maxYValue, 0);
        const styles =
            graphWidth <= 450
                ? {
                      fontSize: 12,
                      fontWeight: "normal"
                  }
                : {
                      fontSize: 14,
                      fontWeight: "bold"
                  };
        const maxYValueTextWidth = Math.ceil(
            getTextWidth(`• ${formattedMaxYValue}`, `${styles.fontWeight} ${styles.fontSize * 0.75}pt Roobert`)
        );

        const containers = $(".retirement-graph-container .bar-values");
        $(containers).each(function (index) {
            if (category === "no-values") {
                $(this).hide();
            } else {
                $(this).show();

                if (graphWidth <= 450) {
                    $(this).outerWidth(maxYValueTextWidth + 20);
                } else {
                    $(this).outerWidth(120);
                }

                const maxPixelY =
                    Math.min(
                        lines["no-pac-value"][index].coords.pixelY,
                        lines["pac-value"][index].coords.pixelY,
                        lines["no-annual-increase-value"][index].coords.pixelY
                    ) || graph.coords.xAxisBorderHeight;

                const containerHeight = $(this).height() + 10;
                let containerWidth = $(this).outerWidth();
                const offset = {
                    top: maxPixelY - containerHeight - 20,
                    left: lines[category][index].coords.pixelX - containerWidth / 2
                };

                $(this).css({ top: offset.top, left: offset.left });
            }
        });
    }
}

function showCashflowInterestRate(inputscenario) {
    if (inputscenario == "scenario1") {
        if (typeof scenario1InterestRateCashflow == "string") {
            $("#portfolio-type-cashflow").val(scenario1InterestRateCashflow);
            $(".other-portfolio-cashflow").hide();
            $(".print-custom").hide();
        }

        if (typeof scenario1InterestRateCashflow == "number") {
            $("#portfolio-type-cashflow").val("other");
            $(".other-portfolio-cashflow").show();
            $("#other-portfolio-cashflow").val(scenario1InterestRateCashflow.toString());
            $(".print-custom").show();
            $("#cash-flow-custom-rate").text(scenario1InterestRateCashflow.toString());
        }
    }

    if (inputscenario == "scenario2") {
        if (typeof scenario2InterestRateCashflow == "string") {
            $("#portfolio-type-cashflow").val(scenario2InterestRateCashflow);
            $(".other-portfolio-cashflow").hide();
            $(".print-custom").hide();
        }

        if (typeof scenario2InterestRateCashflow == "number") {
            $("#portfolio-type-cashflow").val("other");
            $(".other-portfolio-cashflow").show();
            $("#other-portfolio-cashflow").val(scenario2InterestRateCashflow.toString());
            $(".print-custom").show();
            $("#cash-flow-custom-rate").text(scenario2InterestRateCashflow.toString());
        }
    }
}
// update graphs with new input values
function setUpButtons() {
    $(".pdf-pac").css("opacity", "0.5");

    $(".btn-pac").on("click", () => {
        scenario1 = tempScenario1;
        scenario2 = tempScenario2;
        $(".btn-pac").attr("disabled", "true");
        lang === "en" 
            ? $(".update-alert").text("PAC value updated")
            : $(".update-alert").text("Valeur du PAC mise à jour")
        setTimeout(() => {
            $(".update-alert").text("");
        }, 100);
        if (validation()) {
            $(".pdf-pac").prop("disabled", false);
            $(".pdf-pac").css("opacity", "1");
            $(".pac-hint-text").css("display", "none");
            $(".cash-flow > .accordion").removeClass("disabled");
            $(".cash-flow > .accordion").removeAttr("aria-disabled");
            $("#pac-graph").focus();

            if (scenario2) {
                scenario1InterestRateCashflow = scenario1.portfolioType;
                scenario2InterestRateCashflow = scenario2.portfolioType;
                scenario1.interestRateCashFlow = scenario1InterestRateCashflow;
                scenario2.interestRateCashFlow = scenario2InterestRateCashflow;

                if (document.documentElement.clientWidth < 768) {
                    $(".scenarios-text-wide").css({
                        display: "none"
                    });
                    $(".scenarios-text-narrow").css({
                        display: "block"
                    });
                } else {
                    $(".scenarios-text-narrow").css({
                        display: "none"
                    });
                    $(".scenarios-text-wide").css({
                        display: "flex"
                    });
                }

                if ($("#scenario-one").hasClass("selected")) {
                    $("[data-id='scenario1text']").addClass("bold");
                    $("[data-id='scenario2text']").removeClass("bold");
                }

                if ($("#scenario-two").hasClass("selected")) {
                    $("[data-id='scenario2text']").addClass("bold");
                    $("[data-id='scenario1text']").removeClass("bold");
                }

                $("#scenario-one").on("click", function () {
                    $("[data-id='scenario1text']").addClass("bold");
                    $("[data-id='scenario2text']").removeClass("bold");
                });

                $("#scenario-two").on("click", function () {
                    $("[data-id='scenario2text']").addClass("bold");
                    $("[data-id='scenario1text']").removeClass("bold");
                });

                const inputscenario = $("input[name='scenarios']:checked").val();
                showCashflowInterestRate(inputscenario);
            } else {
                $("#scenarios-text").css({
                    display: "none"
                });

                scenario1InterestRateCashflow = scenario1.portfolioType;
                scenario1.interestRateCashFlow = scenario1InterestRateCashflow;

                if (typeof scenario1InterestRateCashflow == "string") {
                    $("#portfolio-type-cashflow").val(scenario1InterestRateCashflow);
                    $(".other-portfolio-cashflow").hide();
                }

                if (typeof scenario1InterestRateCashflow == "number") {
                    $("#portfolio-type-cashflow").val("other");
                    $(".other-portfolio-cashflow").show();
                    $("#other-portfolio-cashflow").val(scenario1InterestRateCashflow.toString());
                }

                scenario1 = getInputValues();
                scenario2 = null;
            }

            const barsVisibilityStatus = getBarsVisibilityStatus();
            if (scenario1.annualIncreaseType === "dollar" || (scenario2 && scenario2.annualIncreaseType === "dollar")) {
                hidePacRetirementLine =
                    scenario1.annualIncreaseDollar === 0 && scenario2 && scenario2.annualIncreaseDollar === 0;
            } else {
                hidePacRetirementLine =
                    scenario1.annualIncreasePercent === 0 && scenario2 && scenario2.annualIncreasePercent === 0;
            }
            if (hidePacRetirementLine) {
                $("#pac-checkbox").prop("checked", false);
            }

            $("#select-all-checkbox").prop("checked", barsVisibilityStatus.showAll);

            drawGraphs();
            $(".err-msg-percent-cashflow").hide();
        } else {
            // focus on first validation error msg
            let errMsgId = "#" + $(".err-msg:visible")[0].getAttribute("data-error");
            $(errMsgId).focus();
            $(".pdf-pac").prop("disabled", true);
            $(".pdf-pac").css("opacity", "0.5");
        }
    });

    $(".btn-pac-print").on("click", function (event) {
        if ($(this).attr("aria-disabled") === "true") {
            event.preventDefault();
        } else {
            updatePrintValues();
        }
    });

    clearInputsButton.on("click", () => {
        clearInputFields();
        lang === "en"
            ? $(".clear-inputs-alert").text("Inputs cleared")
            : $(".clear-inputs-alert").text("Champs effacées")
        setTimeout(() => {
            $(".clear-inputs-alert").text("");
        }, 100);
    });
}

function cashFlowValidation() {
    let values = getInputValues();
    if ($("#portfolio-type-cashflow").val() === "other") {
        if (values.interestRateCashFlow < 0 || values.interestRateCashFlow > 12) {
            return false;
        } else {
            return true;
        }
    }
}

function showCashFlowGraph(scenario, results, results2) {
    if (scenario == "scenario1") {
        drawRetirementCashFlowGraph(results, scenario);
        $("#pac-light-color").addClass("turquoise");
        $("#noAnnualIncrease-medium-color").addClass("green");
        $("#noPac-dark-color").addClass("navy");

        // $("#pac-light-color").removeClass("turquoise");
        // $("#noAnnualIncrease-medium-color").removeClass("green");
        // $("#noPac-dark-color").removeClass("navy");
    }
    if (scenario == "scenario2") {
        drawRetirementCashFlowGraph(results2, scenario);
        $("#pac-light-color").addClass("turquoise");
        $("#noAnnualIncrease-medium-color").addClass("green");
        $("#noPac-dark-color").addClass("navy");

        // $("#pac-light-color").removeClass("turquoise");
        // $("#noAnnualIncrease-medium-color").removeClass("green");
        // $("#noPac-dark-color").removeClass("navy");
    }
}

function getResults(scenario) {
    const { portfolioType, annualIncreasePercent, interestRateCashFlow } = scenario;
    let result = calculateResults({
        ...scenario,
        portfolioType: portfolioType / 100,
        interestRateCashFlow: interestRateCashFlow / 100,
        annualIncreasePercent: annualIncreasePercent / 100
    });
    return result;
}

/**
 * Draw the pre-authorized contributions and retirement cash flow
 * graphs on the page.
 */
let results;
let results2;
function drawGraphs(cashflowOnly, shouldAnimate = true) {
    results = undefined;
    results2 = undefined;
    let interestRate = getValueFromInput("#portfolio-type-cashflow");
    let scenario;
    if (isNaN(interestRate)) {
        interestRate = formatter.parseNumber(getValueFromInput("#other-portfolio-cashflow"));
    }

    // when there are two scenarios
    if ($("#scenario-two").is(":visible")) {
        scenario = $("input[name='scenarios']:checked").val();

        $(".scenarios-cashflow").css({ display: "flex" });
        if (scenario == "scenario1") {
            scenario1.interestRateCashFlow = interestRate;
        }

        if (scenario == "scenario2") {
            scenario2.interestRateCashFlow = interestRate;
        }

        const validity1 = validation();
        const validity2 = validation();

        if (validity1 && validity2) {
            results = lastResults = getResults(scenario1);
            results2 = lastResults2 = getResults(scenario2);
        } else {
            results = lastResults;
            results2 = lastResults2;
        }

        inputValidity = validity1;
        inputValidity2 = validity2;

        if (!cashflowOnly) {
            $(".chart2").removeClass("hide");

            drawPACGraph(results, "#pac-graph0", "#pac-graph0-print", 0, results2, shouldAnimate);
            drawPACGraph(results2, "#pac-graph1", "#pac-graph1-print", 1, results, shouldAnimate);
            $("#pac-graph1").removeAttr("aria-hidden");
            $("#table-pacgraph1").removeAttr("aria-hidden");
        }

        showCashFlowGraph(scenario, results, results2);
    } else {
        scenario = "scenario1";
        // when there is just one scenario

        const validity1 = validation();
        scenario1.interestRateCashFlow = interestRate;

        if (validity1) {
            results = lastResults = getResults(scenario1);
        } else {
            results = lastResults;
        }
        inputValidity = validity1;

        if (!cashflowOnly) {
            $(".chart2").addClass("hide");

            drawPACGraph(results, "#pac-graph0", "#pac-graph0-print", 0, undefined, shouldAnimate);
            const canvas = $("#pac-graph1").get(0);
            const context = canvas.getContext("2d");
            context.clearRect(0, 0, canvas.width, canvas.height);
            $("#pac-graph1").attr("aria-hidden", "true");
            $("#table-pacgraph1").attr("aria-hidden", "true");
        }

        drawRetirementCashFlowGraph(results, scenario);
        $("#pac-light-color").addClass("turquoise");
        $("#noAnnualIncrease-medium-color").addClass("green");
        $("#noPac-dark-color").addClass("navy");

        // $("#pac-light-color").removeClass("navy");
        // $("#noAnnualIncrease-medium-color").removeClass("green");
        // $("#noPac-dark-color").removeClass("turquoise");
    }

    $("input[name='scenarios']")
        .off("change.cashflow")
        .on("change.cashflow", () => {
            scenario1.interestRateCashFlow = scenario1InterestRateCashflow;
            scenario2.interestRateCashFlow = scenario2InterestRateCashflow;
            scenario = $("input[name='scenarios']:checked").val();
            showCashflowInterestRate(scenario);

            results = lastResults = getResults(scenario1);
            results2 = lastResults2 = getResults(scenario2);

            showCashFlowGraph(scenario, results, results2);
        });

    $("#portfolio-type-cashflow")
        .off("change.cashflow")
        .on("change.cashflow", () => {
            scenario = $("input[name='scenarios']:checked").val();
            interestRate = getValueFromInput("#portfolio-type-cashflow");
            if (isNaN(interestRate)) {
                interestRate = formatter.parseNumber(getValueFromInput("#other-portfolio-cashflow"));
            }

            if (scenario === "scenario1") {
                scenario1InterestRateCashflow = interestRate;
                scenario1.interestRateCashFlow = interestRate;
                results = lastResults = getResults(scenario1);
            }

            if (scenario2) {
                if (scenario === "scenario2") {
                    scenario2InterestRateCashflow = interestRate;
                    scenario2.interestRateCashFlow = interestRate;
                    results2 = lastResults2 = getResults(scenario2);
                }
            }

            showCashFlowGraph(scenario, results, results2);
        });

    $("#other-portfolio-cashflow")
        .off("change.cashflow blur.cashflow keyup.cashflow")
        .on("change.cashflow blur.cashflow keyup.cashflow", () => {
            //setting up max length for custom text of of cashflow graph
            if (
                (lang === "en" && $("#other-portfolio-cashflow").val().indexOf(".") > -1) ||
                (lang === "fr" && $("#other-portfolio-cashflow").val().indexOf(",") > -1)
            ) {
                $("#other-portfolio-cashflow").attr("maxlength", null);
            } else {
                $("#other-portfolio-cashflow").attr("maxlength", 2);
            }

            // if ($(".scenarios-cashflow").is(":visible")) {

            // } else {

            // }

            //drawing the cashflow graph
            if (cashFlowValidation()) {
                if (scenario == "scenario2") {
                    scenario2InterestRateCashflow = formatter.parseNumber(
                        getValueFromInput("#other-portfolio-cashflow")
                    );
                    scenario2.interestRateCashFlow = scenario2InterestRateCashflow;
                    results2 = lastResults2 = getResults(scenario2);
                }
                if (scenario == "scenario1") {
                    scenario1InterestRateCashflow = formatter.parseNumber(
                        getValueFromInput("#other-portfolio-cashflow")
                    );
                    scenario1.interestRateCashFlow = scenario1InterestRateCashflow;
                    results = lastResults = getResults(scenario1);
                }
                showCashFlowGraph(scenario, results, results2);
            }
        });
}

function validation(eventType, targetID) {
    const values = getInputValues();
    const maximumDollarIncrease = Number(values.contributionAmount) || 0;
    $("[data-annual-dollar]").text(formatter.formatCurrency(maximumDollarIncrease));

    let inputsForValidation = "all";
    if (targetID) {
        inputsForValidation = targetID;
    }

    let validity = true;

    if (inputsForValidation === "all" || inputsForValidation === "starting-amount") {
        const startingAmount = Number(values.startingAmount) || 0;
        if (startingAmount < 0 || startingAmount > 1000000) {
            if (eventType !== "keyup") {
                $('[data-error="starting-amount"]').show();
                $("#starting-amount").attr("aria-invalid", "true");
            }
            validity = false;
        } else {
            $('[data-error="starting-amount"]').hide();
            $("#starting-amount").removeAttr("aria-invalid");
        }
    }

    if (inputsForValidation === "all" || inputsForValidation === "contribution-amount") {
        const contributionAmount = Number(values.contributionAmount) || 0;
        if (contributionAmount < 25 || contributionAmount > 50000) {
            if (eventType !== "keyup") {
                $('[data-error="contribution-amount"]').show();
                $("#contribution-amount").attr("aria-invalid", "true");
            }
            validity = false;
        } else {
            $('[data-error="contribution-amount"]').hide();
            $("#contribution-amount").removeAttr("aria-invalid");
        }
    }

    if (inputsForValidation === "all" || inputsForValidation === "number-of-years") {
        const numberYears = Number(values.numberYears) || 0;
        if (numberYears < 1 || numberYears > 50) {
            if (eventType !== "keyup") {
                $('[data-error="number-of-years"]').show();
                $("#number-of-years").attr("aria-invalid", "true");
            }
            validity = false;
        } else {
            $('[data-error="number-of-years"]').hide();
            $("#number-of-years").removeAttr("aria-invalid");
        }
    }

    if ($("#portfolio-type").val() === "other") {
        if (inputsForValidation === "all" || inputsForValidation === "other-portfolio") {
            const portfolioType = Number(values.portfolioType) || 0;
            if (portfolioType < 0 || portfolioType > 12) {
                if (eventType !== "keyup") {
                    $('[data-error="other-portfolio"]').show();
                    $("#other-portfolio").attr("aria-invalid", "true");
                }
                validity = false;
            } else {
                $('[data-error="other-portfolio"]').hide();
                $("#other-portfolio").removeAttr("aria-invalid");
            }
        }
    }

    if (values.annualIncreaseType === "dollar") {
        if (inputsForValidation === "all" || inputsForValidation === "annual-increase-dollar") {
            const annualIncreaseDollar = Number(values.annualIncreaseDollar) || 0;
            $('[data-error="annual-increase-percent"]').hide();
            $("#annual-increase-percent").removeAttr("aria-invalid");
            $("[data-annual]").text(formatter.formatCurrency(annualIncreaseDollar));

            if (annualIncreaseDollar < 0 || annualIncreaseDollar > maximumDollarIncrease) {
                if (eventType !== "keyup") {
                    $('[data-error="annual-increase-dollar"]').show();
                    $("#annual-increase-dollar").attr("aria-invalid", "true");
                }
                validity = false;
            } else {
                $('[data-error="annual-increase-dollar"]').hide();
                $("#annual-increase-dollar").removeAttr("aria-invalid");
            }
        }
    } else {
        if (inputsForValidation === "all" || inputsForValidation === "annual-increase-percent") {
            const annualIncreasePercent = Number(values.annualIncreasePercent) || 0;
            $('[data-error="annual-increase-dollar"]').hide();
            $("#annual-increase-dollar").removeAttr("aria-invalid");
            $("[data-annual]").text(formatter.formatPercentage(annualIncreasePercent));
            if (annualIncreasePercent < 0 || annualIncreasePercent > 10) {
                if (eventType !== "keyup") {
                    $('[data-error="annual-increase-percent"]').show();
                    $("#annual-increase-percent").attr("aria-invalid", "true");
                }
                validity = false;
            } else {
                $('[data-error="annual-increase-percent"]').hide();
                $("#annual-increase-percent").removeAttr("aria-invalid");
            }
        }
    }

    return validity;
}

function videoInputsValidation() {
    const values = getVideoInputValues();

    if (values.name === "") {
        $('[data-error="name"]').css("display", "block");
        $("#name").attr("aria-invalid", "true");
        return false;
    } else {
        $('[data-error="name"]').hide();
        $("#name").removeAttr("aria-invalid");
    }

    if (values.startingAmount < 0 || values.startingAmount > 500000) {
        $('[data-error="starting-amount-video"]').css("display", "block");
        $("#starting-amount-video").attr("aria-invalid", "true");
        return false;
    } else {
        $('[data-error="starting-amount-video"]').hide();
        $("#starting-amount-video").removeAttr("aria-invalid");
    }

    if (values.contributionAmount < 1 || values.contributionAmount > 50000 || !values.contributionAmount) {
        $('[data-error="contribution-amount-video"]').css("display", "block");
        $("#contribution-amount-video").attr("aria-invalid", "true");
        return false;
    } else {
        $('[data-error="contribution-amount-video"]').hide();
        $("#contribution-amount-video").removeAttr("aria-invalid");
    }

    if (
        values.contributionIncrease < 0 ||
        values.contributionIncrease > 10 ||
        typeof values.contributionIncrease !== "number"
    ) {
        $('[data-error="annual-percentage-increase-video"]').css("display", "block");
        $("#annual-percentage-increase-video").attr("aria-invalid", "true");
        return false;
    } else {
        $('[data-error="annual-percentage-increase-video"]').hide();
        $("#annual-percentage-increase-video").removeAttr("aria-invalid");
    }

    return true;
}

function fillFieldsOnBlur() {
    // Ensures that inputs are not blank if user deletes number, fills input with 0
    $(".pac-container")
        .find("input, select")
        .on("blur", () => {
            const values = getInputValues();

            for (const value in values) {
                if (!values[value]) {
                    values[value] = 0;
                }
            }

            $("#starting-amount").val(formatter.formatNumber(values.startingAmount));
            $("#contribution-amount").val(formatter.formatNumber(values.contributionAmount));
            $("#number-of-years").val(formatter.formatNumber(values.numberYears));
            $("#annual-increase-percent").val(formatter.formatNumber(values.annualIncreasePercent));
            $("#annual-increase-dollar").val(formatter.formatNumber(values.annualIncreaseDollar));
            $("#other-portfolio").val(formatter.formatNumber(values.portfolioType));
            setInputMaxLengths();
        });

    $(".cash-flow")
        .find("#other-portfolio-cashflow")
        .on("blur", () => {
            let value = getValueFromInput("#other-portfolio-cashflow");
            if (!value) {
                value = 0;
            }

            $("#other-portfolio-cashflow").val(formatter.formatNumber(value));
        });
}

function setInputMaxLengths() {
    const contributionAmountLength = formatter
        .parseNumber(getValueFromInput("[name='contributionAmount']") || "0")
        .toString().length;
    const maxLengths = {
        startingAmount: {
            decimal: 9,
            integer: 7
        },
        contributionAmount: {
            decimal: 7,
            integer: 5
        },
        otherPortfolio: {
            decimal: null,
            integer: 2
        },
        otherPortfolioCashflow: {
            decimal: null,
            integer: 2
        },
        annualIncreasePercent: {
            decimal: null,
            integer: 2
        },
        annualIncreaseDollar: {
            decimal: contributionAmountLength + 3,
            integer: contributionAmountLength
        }
    };
    const inputNames = [
        "startingAmount",
        "contributionAmount",
        "otherPortfolio",
        "annualIncreasePercent",
        "annualIncreaseDollar"
    ];
    inputNames.forEach((inputName) => {
        const value = getValueFromInput(`[name=${inputName}]`) || "0";
        let numberType;

        if ((lang === "en" && value.indexOf(".") > -1) || (lang === "fr" && value.indexOf(",") > -1)) {
            numberType = "decimal";
        } else {
            numberType = "integer";
        }

        const maxLength = maxLengths[inputName][numberType];

        $(`[name=${inputName}]`).attr("maxlength", maxLength);
    });
}

function restrictInputs() {
    $("input").on("keyup", function () {
        const name = $(this).attr("name");
        const value = getValueFromInput(`[name=${name}]`);
        const currencyFields = ["startingAmount", "contributionAmount", "annualIncreaseDollar"];
        const percentageFields = ["otherPortfolio", "annualIncreasePercent"];
        const integerFields = ["numberYears"];

        if (currencyFields.indexOf(name) > -1) {
            let finalValue = value;

            if (
                (lang === "en" && (finalValue.match(/\./g) || []).length >= 2) ||
                (lang === "fr" && (finalValue.match(/,/g) || []).length >= 2)
            ) {
                finalValue = finalValue.slice(0, finalValue.length - 1);
            }

            if ((lang === "en" && finalValue.indexOf(".") > -1) || (lang === "fr" && finalValue.indexOf(",") > -1)) {
                const decimalSymbol = lang === "en" ? "." : ",";
                const decimalByParts = finalValue.split(decimalSymbol);
                const beforeDecimal = decimalByParts[0];
                const afterDecimal = decimalByParts[1].slice(0, 2);
                finalValue = `${beforeDecimal}${decimalSymbol}${afterDecimal}`;
            }

            if (finalValue !== value) {
                $(this).val(finalValue);
            }

            if (name === "contributionAmount") {
                const maximumDollarIncrease = Math.max(finalValue || 0, 25);
                $("[data-annual-dollar]").text(formatter.formatCurrency(maximumDollarIncrease));
            } else if (name === "annualIncreaseDollar" && $("#annual-increase-type-dollar").is(":checked")) {
                $("[data-annual]").text(formatter.formatCurrency(finalValue || 0));
            }
        } else if (percentageFields.indexOf(name) > -1) {
            let finalValue = value;

            if (
                (lang === "en" && (finalValue.match(/\./g) || []).length >= 2) ||
                (lang === "fr" && (finalValue.match(/,/g) || []).length >= 2)
            ) {
                finalValue = finalValue.slice(0, finalValue.length - 1);
            }

            if (finalValue !== value) {
                $(this).val(finalValue);
            }
        } else if (integerFields.indexOf(name) > -1) {
            let finalValue = value;

            if (
                (lang === "en" && (finalValue.match(/\./g) || []).length > 0) ||
                (lang === "fr" && (finalValue.match(/,/g) || []).length > 0)
            ) {
                finalValue = finalValue.slice(0, finalValue.length - 1);
            }

            if (finalValue !== value) {
                $(this).val(finalValue);
            }
        }
        setInputMaxLengths();
    });
}

function setUpNumericInputs() {
    const elements = document.getElementsByClassName("numeric");

    for (let i = 0; i < elements.length; i++) {
        RMNumberInput(elements[i], { inputmode: "numeric" });
    }

    $(".numeric").on("focus", function () {
        let preVal = $(this).val();
        if (lang === "fr") {
            preVal = preVal.replace(/,/g, ".");
        }

        if (isNaN(preVal)) {
            if (lang === "fr") {
                preVal = preVal.replace(/\./g, ",");
            }

            let value = formatter.parseNumber(preVal).toString();

            if (lang === "fr") {
                value = value.replace(/\./g, ",");
            }

            $(this).val(value).trigger("select");
        } else {
            if (Number(preVal) > 0) {
                $(this).trigger("select");
            } else {
                $(this).val("");
            }
        }
    });

    $(".pac-container .numeric, .cash-flow .numeric").on("keyup", ({ target }) => {
        const input = $(target);

        input.val(
            input
                .val()
                .replace(/[^0-9.]/g, "")
                .replace(".", "x")
                .replace(/\./g, "")
                .replace("x", ".")
        );
    });
}

function setUpCheckboxes() {
    $('input[name="cashFlowCheckboxes"]').on("change", function () {
        const checkboxId = $(this).attr("id");
        const checked = $(this).is(":checked");

        if (checkboxId === "select-all-checkbox") {
            $('input[name="cashFlowCheckboxes"]').prop("checked", checked);
        } else if (!checked) {
            $("#select-all-checkbox").prop("checked", checked);
        } else {
            const barsVisibilityStatus = getBarsVisibilityStatus();
            if (barsVisibilityStatus.showAll) {
                $("#select-all-checkbox").prop("checked", checked);
            }
        }
    });
}

function updateRetirementCheckboxes(newCheckboxes) {
    retirementCheckboxes = newCheckboxes;
}

function setUpPopups() {
    const infoIconPopups = $(".info-icon-popup");

    infoIconPopups
        .attr({
            role: "button",
            "aria-hidden": "false",
            "aria-label": "tooltip"
        })
        .on("click", function (event) {
            event.preventDefault();
            var hoverEl = $(this).children(".icon-hover");
            var html = hoverEl.html();
            hoverEl.html("");
            setTimeout(function () {
                hoverEl.html(html);
            }, 0);
        })
        .on("mouseenter", function () {
            infoIconPopups.not($(this)).trigger("blur");
        })
        .children(".icon-hover")
        .attr({ role: "status", "aria-atomic": "true" });
}

function setUpCustomRateVisiblity() {
    $("#portfolio-type").on("change", () => {
        let portfolioType = getValueFromInput("#portfolio-type");

        if (isNaN(portfolioType)) {
            $(".other-portfolio").show();
        } else {
            $("#other-portfolio").val(0).removeAttr("aria-invalid");
            $("[data-error='other-portfolio']").hide();
            $(".other-portfolio").hide();
        }
    });

    $("#portfolio-type-cashflow").on("change", () => {
        let portfolioType = getValueFromInput("#portfolio-type-cashflow");

        if (isNaN(portfolioType)) {
            $(".other-portfolio-cashflow").show();
        } else {
            $("#other-portfolio-cashflow").val(0).removeAttr("aria-invalid");
            $("[data-error='other-portfolio-cashflow']").hide();
            $(".other-portfolio-cashflow").hide();
        }
    });
}

// toggle between % and $ Annual PAC increase
function setUpAnnualPACIncreaseVisibility() {
    $(".annual-increase-container input[name='annualIncreaseType']")
        .on("change", () => {
            const annualIncreaseType = $("input[name='annualIncreaseType']:checked").val();

            if (annualIncreaseType === "percent") {
                $("#annual-increase-dollar").prop("disabled", true).val(0);
                $(".dollar-input-increase").addClass("disabled-input-parent").hide();
                $("#annual-increase-percent").prop("disabled", false);
                $(".percentage-input-increase").removeClass("disabled-input-parent").show();
            } else {
                $("#annual-increase-dollar").prop("disabled", false);
                $(".dollar-input-increase").removeClass("disabled-input-parent").show();
                $("#annual-increase-percent").prop("disabled", true).val(0);
                $(".percentage-input-increase").addClass("disabled-input-parent").hide();
            }
        })
        .trigger("change");
}

function setUpWatchVideoButton() {
    $(".btn-watch-vid").prop("disabled", true);
    $(".play-btn-small").prop("disabled", true);

    $(".btn-watch-vid, .play-btn-small").on("click", ({ target }) => {
        $(".cp-controls").css("display", "flex");
        const values = getVideoInputValues();

        if (
            values.name === "" &&
            values.startingAmount <= 0 &&
            values.contributionAmount <= 0 &&
            values.contributionIncrease <= 0
        ) {
            $(".play-btn-small").css("bottom", "60px");
            $(".pac-video-msg").show();
        }

        $(".btn-watch-vid").attr("disabled", "true");
        $(".play-btn-small").css("bottom", "30px");
        $(".pac-video-msg").hide();
        if (!videoInputsValidation()) {
            const firstInvalidInput = document.querySelector("input[aria-invalid]");
            firstInvalidInput.focus();
        } else {
            $(".play-btn-small").hide();
            $(".pac-video-thumbnail").hide();

            let { contributionIncrease, contributionAmount, name, startingAmount } = getVideoInputValues();

            if (contributionIncrease === 0) {
                contributionIncrease = 3;
            }

            const results = calculateVideoResults({
                annualPercentageIncrease: contributionIncrease,
                contributionAmount,
                startingAmount
            });

            pacStorage.pacName = name;
            pacStorage.pacNameUppercase = name.toUpperCase();
            pacStorage.pacStartingAmount = formatter.formatCurrency(startingAmount, 0);
            pacStorage.pacMonthlyAmount = formatter.formatCurrency(contributionAmount, 0);
            pacStorage.pacAnnualPercentageIncrease = contributionIncrease;
            pacStorage.results = results;
            var smartRounding = (contributionAmount / 2) % 1 != 0 ? 2 : 0;
            pacStorage.pacBiWeeklyAmount = formatter.formatCurrency(contributionAmount / 2, smartRounding);
            pacStorage.pacBiWeeklyDifference = formatter.formatCurrency(
                pacStorage.results.biWeeklyContributions.withIncrease.thirtyYears -
                    pacStorage.results.monthlyContributions.withIncrease.thirtyYears,
                0
            );
            pacStorage.total = formatter.formatCurrency(
                pacStorage.results.biWeeklyContributions.withIncrease.thirtyYears,
                0
            );
            pacStorage.pacBiWeeklyExtraDifference = pacStorage.pacBiWeeklyExtraSavings - pacStorage.pacMonthlySavings;
            pacStorage.pacDate = formatter.formatDate(new Date(), "yyyy-mm-dd");
            pacStorage.formattedOutput = {
                pacMonthlyAmount: formatter.formatCurrency(pacStorage.pacMonthlyAmount, 0),
                pacMonthlySavings: formatter.formatCurrency(pacStorage.pacMonthlySavings, 0),
                pacBiWeeklyAmount: formatter.formatCurrency(pacStorage.pacBiWeeklyAmount, 2),
                pacBiWeeklySavings: formatter.formatCurrency(pacStorage.pacBiWeeklySavings, 0),
                pacBiWeeklyDifference: formatter.formatCurrency(pacStorage.pacBiWeeklyDifference, 0),
                pacBiWeeklyExtraSavings: formatter.formatCurrency(pacStorage.pacBiWeeklyExtraSavings, 0),
                pacBiWeeklyExtraDifference: formatter.formatCurrency(pacStorage.pacBiWeeklyExtraDifference, 0)
            };

            pacStorage.results.biWeeklyContributions.withIncrease = roundValuesInObject(
                pacStorage.results.biWeeklyContributions.withIncrease
            );
            pacStorage.results.biWeeklyContributions.withoutIncrease = roundValuesInObject(
                pacStorage.results.biWeeklyContributions.withoutIncrease
            );
            pacStorage.results.monthlyContributions.withIncrease = roundValuesInObject(
                pacStorage.results.monthlyContributions.withIncrease
            );
            pacStorage.results.monthlyContributions.withoutIncrease = roundValuesInObject(
                pacStorage.results.monthlyContributions.withoutIncrease
            );

            initPlayer(true);
        }
    });
}

function setUpRetirementCashFlowAccordion() {
    $(".cash-flow > .accordion").on("click", function () {
        if (!$(this).hasClass("disabled") && !$(".err-msg").is(":visible")) {
            drawGraphs(true);
        }
    });
}

// formats the amount and removes the $ from formatting currency
function formatVideoInputValues(val) {
    return lang === "en" ? formatter.formatCurrency(val).substr(1) : formatter.formatCurrency(val).slice(0, -1);
}

// real time validation for input fields
function setupRealTimeErrorChecking() {
    $(".cashflow-inputs")
        .find("input")
        .on({
            blur: (event) => {
                const id = event.currentTarget.id;
                const dataError = "[data-error='" + id + "']";
                if ($("#other-portfolio-cashflow").val() < 0 || $("#other-portfolio-cashflow").val() > 12) {
                    $("#other-portfolio-cashflow").attr("aria-invalid", "true");
                    $(dataError).show();
                }
            },
            keyup: (event) => {
                if (event.keyCode != 16 && event.keyCode != 9) {
                    const id = event.currentTarget.id;
                    const dataError = "[data-error='" + id + "']";

                    if ($("#other-portfolio-cashflow").val() < 0 || $("#other-portfolio-cashflow").val() > 12) {
                        $("#other-portfolio-cashflow").attr("aria-invalid", "true");
                        $(dataError).show();
                    }

                    if ($("#other-portfolio-cashflow").val() <= 12) {
                        $(dataError).hide();
                        $("#other-portfolio").removeAttr("aria-invalid");
                    }
                }
            }
        });
    $(".pac-container")
        .find("input")
        .on({
            blur: (event) => {
                const id = event.currentTarget.id;
                const dataError = "[data-error='" + id + "']";
                const values = getInputValues();
                let val = "";

                switch (id) {
                    case "starting-amount":
                        val = values.startingAmount;
                        if (val < 0 || val > 1000000) {
                            $(".btn-pac").prop("disabled", true);
                            $(".pdf-pac").prop("disabled", true);
                            $(".pdf-pac").css("opacity", "0.5");
                            $(dataError).show();
                            $("#starting-amount").attr("aria-invalid", "true");
                        }
                        break;
                    case "contribution-amount":
                        val = values.contributionAmount;
                        if (val < 25 || val > 50000) {
                            $(".btn-pac").prop("disabled", true);
                            $(".pdf-pac").prop("disabled", true);
                            $(".pdf-pac").css("opacity", "0.5");
                            $(dataError).show();
                            $("#contribution-amount").attr("aria-invalid", "true");
                        }
                        break;
                    case "number-of-years":
                        val = values.numberYears;
                        if (val < 1 || val > 50) {
                            $(".btn-pac").prop("disabled", true);
                            $(".pdf-pac").prop("disabled", true);
                            $(".pdf-pac").css("opacity", "0.5");
                            $(dataError).show();
                            $("#number-of-years").attr("aria-invalid", "true");
                        }
                        break;
                    case "other-portfolio":
                        val = $("#other-portfolio").val();
                        if (val < 0 || val > 12) {
                            $(".btn-pac").prop("disabled", true);
                            $(".pdf-pac").prop("disabled", true);
                            $(".pdf-pac").css("opacity", "0.5");
                            $(dataError).show();
                            $("#other-portfolio").attr("aria-invalid", "true");
                        }
                        break;
                    case "annual-increase-percent":
                        val = values.annualIncreasePercent;
                        if (val < 0 || val > 10) {
                            $(".btn-pac").prop("disabled", true);
                            $(".pdf-pac").prop("disabled", true);
                            $(".pdf-pac").css("opacity", "0.5");
                            $(dataError).show();
                            $("#annual-increase-percent").attr("aria-invalid", "true");
                        }
                        break;
                    case "annual-increase-dollar":
                        val = values.annualIncreaseDollar;
                        if (val < 0 || val > values.contributionAmount) {
                            $(".btn-pac").prop("disabled", true);
                            $(".pdf-pac").prop("disabled", true);
                            $(".pdf-pac").css("opacity", "0.5");
                            $(dataError).show();
                            $("#annual-increase-dollar").attr("aria-invalid", "true");
                        }
                        break;
                }
            },
            keyup: (event) => {
                if (event.keyCode != 16 && event.keyCode != 9) {
                    const id = event.currentTarget.id;
                    const dataError = "[data-error='" + id + "']";
                    const values = getInputValues();
                    let val = "";
                    switch (id) {
                        case "starting-amount":
                            val = values.startingAmount;
                            if (val <= 1000000) {
                                $(dataError).hide();
                                $("#starting-amount").removeAttr("aria-invalid");
                            }
                            if ($("starting-amount-err-msg").is(":visible")) {
                                $(".btn-pac").prop("disabled", true);
                                $(".pdf-pac").prop("disabled", true);
                            }
                            break;
                        case "contribution-amount":
                            val = values.contributionAmount;
                            if (val >= 25) {
                                $(dataError).hide();
                                $("#contribution-amount").removeAttr("aria-invalid");
                            }
                            if ($("#contribution-amount-err-msg").is(":visible")) {
                                $(".btn-pac").prop("disabled", true);
                                $(".pdf-pac").prop("disabled", true);
                            }
                            break;
                        case "number-of-years":
                            val = values.numberYears;
                            if (val >= 1) {
                                $(dataError).hide();
                                $("#number-of-years").removeAttr("aria-invalid");
                            }
                            if ($("#number-of-years-err-msg").is(":visible")) {
                                $(".btn-pac").prop("disabled", true);
                                $(".pdf-pac").prop("disabled", true);
                            }
                            break;
                        case "other-portfolio":
                            val = $("#other-portfolio").val();
                            if (val <= 12) {
                                $(dataError).hide();
                                $("#other-portfolio").removeAttr("aria-invalid");
                            }
                            if ($("#other-portfolio-err-msg").is(":visible")) {
                                $(".btn-pac").prop("disabled", true);
                                $(".pdf-pac").prop("disabled", true);
                            }
                            break;
                        case "annual-increase-percent":
                            val = values.annualIncreasePercent;
                            if (val <= 10) {
                                $(dataError).hide();
                                $("#annual-increase-percent").removeAttr("aria-invalid");
                            }
                            if ($("#annual-increase-percent-err-msg").is(":visible")) {
                                $(".btn-pac").prop("disabled", true);
                                $(".pdf-pac").prop("disabled", true);
                            }
                            break;
                        case "annual-increase-dollar":
                            val = values.annualIncreaseDollar;
                            if (val <= values.contributionAmount) {
                                $(dataError).hide();
                                $("#annual-increase-dollar").removeAttr("aria-invalid");
                            }
                            if ($("#annual-increase-dollar-err-msg").is(":visible")) {
                                $(".btn-pac").prop("disabled", true);
                                $(".pdf-pac").prop("disabled", true);
                            }
                            break;
                        case "annual-increase-type-percent":
                            val = values.annualIncreasePercent;
                            if ($("#annual-increase-dollar-err-msg").is(":visible")) {
                                $("#annual-increase-dollar-err-msg").hide();
                                $("#annual-increase-type-percent").removeAttr("aria-invalid");
                            }
                            if (val < 0 || val > 10) {
                                $("#annual-increase-percent-err-msg").show();
                                $(".btn-pac").prop("disabled", true);
                                $(".pdf-pac").prop("disabled", true);
                            }
                            break;
                        case "annual-increase-type-dollar":
                            val = values.annualIncreaseDollar;
                            if ($("#annual-increase-percent-err-msg").is(":visible")) {
                                $("#annual-increase-percent-err-msg").hide();
                                $("#annual-increase-type-dollar").removeAttr("aria-invalid");
                            }
                            if (val < 0 || val > values.contributionAmount) {
                                $(".btn-pac").prop("disabled", true);
                                $(".pdf-pac").prop("disabled", true);
                                $("#annual-increase-dollar-err-msg").show();
                                $("#annual-increase-type-dollar").attr("aria-invalid", "true");
                            }
                            break;
                    }
                }
            },
            click: (event) => {
                const id = event.currentTarget.id;
                const values = getInputValues();
                let val = "";

                switch (id) {
                    case "annual-increase-type-percent":
                        val = values.annualIncreasePercent;
                        if ($("#annual-increase-dollar-err-msg").is(":visible")) {
                            $("#annual-increase-dollar-err-msg").hide();
                            $("#annual-increase-type-dollar").removeAttr("aria-invalid");
                        }
                        if (val < 0 || val > 10) {
                            $(".btn-pac").prop("disabled", true);
                            $(".pdf-pac").prop("disabled", true);
                            $("#annual-increase-percent-err-msg").show();
                            $("#annual-increase-type-percent").attr("aria-invalid", "true");
                        }
                        break;
                    case "annual-increase-type-dollar":
                        val = values.annualIncreaseDollar;
                        if ($("#annual-increase-percent-err-msg").is(":visible")) {
                            $("#annual-increase-percent-err-msg").hide();
                            $("#annual-increase-type-percent").removeAttr("aria-invalid");
                        }
                        if (val < 0 || val > values.contributionAmount) {
                            $(".btn-pac").prop("disabled", true);
                            $(".pdf-pac").prop("disabled", true);
                            $("#annual-increase-dollar-err-msg").show();
                            $("#annual-increase-type-dollar").attr("aria-invalid", "true");
                        }
                        break;
                }
            }
        });

    function runValidation() {

    }

    $(".pac-video")
        .find("input")
        .on({
            blur: (event) => {
                const id = event.currentTarget.id;
                const dataError = "[data-error='" + id + "']";
                const values = getVideoInputValues();
                let val = "";

                switch (id) {
                    case "name":
                        val = values.name;
                        if (val === "") {
                            $(".btn-watch-vid").prop("disabled", true);
                            $(".play-btn-small").prop("disabled", true);
                            $(dataError).css("display", "block");
                            $("#name").attr("aria-invalid", "true");
                        } else {
                            $(dataError).hide();
                            $("#name").removeAttr("aria-invalid");
                        }
                        break;
                    case "starting-amount-video":
                        val = values.startingAmount;
                        if (!val) {
                            $("#starting-amount-video").val("0");
                        }
                        if (val < 0 || val > 500000) {
                            $(".btn-watch-vid").prop("disabled", true);
                            $(".play-btn-small").prop("disabled", true);
                            $(dataError).css("display", "block");
                            $("#starting-amount-video").attr("aria-invalid", "true");
                        } else {
                            $(dataError).hide();
                            $("#starting-amount-video").removeAttr("aria-invalid");
                            if (val > 0 && val > 999) {
                                $("#starting-amount-video").attr("maxlength", "7");
                                $("#starting-amount-video").val(formatVideoInputValues(val));
                            }
                        }
                        break;
                    case "contribution-amount-video":
                        val = values.contributionAmount;
                        if (!val) {
                            $("#contribution-amount-video").val("0");
                        }
                        if (val < 1 || val > 50000) {
                            $(".btn-watch-vid").prop("disabled", true);
                            $(".play-btn-small").prop("disabled", true);
                            $(dataError).css("display", "block");
                            $("#contribution-amount-video").attr("aria-invalid", "true");
                        } else {
                            $(dataError).hide();
                            $("#contribution-amount-video").removeAttr("aria-invalid");
                            if (val > 0 && val > 999) {
                                $("#contribution-amount-video").attr("maxlength", "6");
                                $("#contribution-amount-video").val(formatVideoInputValues(val));
                            }
                        }
                        break;
                    case "annual-percentage-increase-video":
                        val = values.contributionIncrease;
                        if (!val) {
                            $("#annual-percentage-increase-video").val("0");
                        }
                        if (val < 0 || val > 10) {
                            $(".btn-watch-vid").prop("disabled", true);
                            $(".play-btn-small").prop("disabled", true);
                            $(dataError).css("display", "block");
                            $("#annual-percentage-increase-video").attr("aria-invalid", "true");
                        } else {
                            $(dataError).hide();
                            $("#annual-percentage-increase-video").removeAttr("aria-invalid");
                        }
                        break;
                }
            },
            keyup: (event) => {
                if (event.keyCode != 16 && event.keyCode != 9) {
                    const id = event.currentTarget.id;
                    const dataError = "[data-error='" + id + "']";
                    const values = getVideoInputValues();
                    let val = "";
                    switch (id) {
                        case "name":
                            val = values.name;
                            if (val === "") {
                                $(".btn-watch-vid").prop("disabled", true);
                                $(".play-btn-small").prop("disabled", true);
                                $(dataError).css("display", "block");
                                $("#name").attr("aria-invalid", "true");
                            } else {
                                $(dataError).hide();
                                $("#name").removeAttr("aria-invalid");
                            }
                            break;
                        case "starting-amount-video":
                            val = values.startingAmount;
                            if (val < 0 || val > 500000) {
                                $(".btn-watch-vid").prop("disabled", true);
                                $(".play-btn-small").prop("disabled", true);
                                $(dataError).css("display", "block");
                                $("#starting-amount-video").attr("aria-invalid", "true");
                            } else {
                                $(dataError).hide();
                                $("#starting-amount-video").removeAttr("aria-invalid");
                            }
                            break;
                        case "contribution-amount-video":
                            val = values.contributionAmount;
                            if (val < 1 || val > 50000) {
                                $(".btn-watch-vid").prop("disabled", true);
                                $(".play-btn-small").prop("disabled", true);
                                $(dataError).css("display", "block");
                                $("#contribution-amount-video").attr("aria-invalid", "true");
                            } else {
                                $(dataError).hide();
                                $("#contribution-amount-video").removeAttr("aria-invalid");
                            }
                            break;
                        case "annual-percentage-increase-video":
                            val = values.contributionIncrease;
                            if (val < 1 || val > 10) {
                                $(".btn-watch-vid").prop("disabled", true);
                                $(".play-btn-small").prop("disabled", true);
                                $(dataError).css("display", "block");
                                $("#annual-percentage-increase-video").attr("aria-invalid", "true");
                            } else {
                                $(dataError).hide();
                                $("#annual-percentage-increase-video").removeAttr("aria-invalid");
                            }
                            break;
                    }
                }
            }
        });
}

function addRemoveScenario() {
    $("#add-scenario").on("click", function () {
        if (validation()) {
            temScenario1 = getInputValues();

            $("#scenario-two").removeClass("hide");
            $("#scenario-two").addClass("selected");
            $("#scenario-one").removeClass("selected");
            $("#scenario-one").attr("aria-selected", false);
            $("#add-scenario").addClass("hide");
            $("#remove-scenario").removeClass("hide");
            $("#scenario-two").attr("aria-selected", true);
            $("#scenario-two").trigger("focus");

            clearInputFields();
            $("#annual-increase-percent").prop("disabled", false);
            $("#annual-increase-dollar").prop("disabled", true);
            $(".percentage-input-increase").show();
            $(".dollar-input-increase").hide();
        } else {
            // focus on the first input with a validation error
            if ($('[data-error="starting-amount"]').is(":visible")) {
                $("#starting-amount").trigger("focus");
            } else if ($('[data-error="contribution-amount"]').is(":visible")) {
                $("#contribution-amount").trigger("focus");
            } else if ($('[data-error="number-of-years"]').is(":visible")) {
                $("#number-of-years").trigger("focus");
            } else if ($('[data-error="other-portfolio"]').is(":visible")) {
                $("#other-portfolio").trigger("focus");
            } else if ($('[data-error="annual-increase-percent"]').is(":visible")) {
                $("#annual-increase-percent").trigger("focus");
            } else if ($('[data-error="annual-increase-dollar"]').is(":visible")) {
                $("#annual-increase-dollar").trigger("focus");
            }
        }
    });

    $("#scenario-one").on("click", function () {
        if (validation()) {
            $("#scenario-one").attr("aria-selected", true);
            $("#scenario-two").attr("aria-selected", false);
            $("#add-scenario").trigger("focus");
            $(".pac-container .err-msg").hide();
            $(".pac-container .err-msg").removeAttr("aria-invalid");
            if ($("#scenario-two").is(":visible") && $("#scenario-two").hasClass("selected")) {
                temScenario2 = getInputValues();

                $("#scenario-one").addClass("selected");
                $("#scenario-two").removeClass("selected");

                $("#starting-amount").val(formatter.formatNumber(temScenario1.startingAmount));
                $("#contribution-amount").val(formatter.formatNumber(temScenario1.contributionAmount));
                $("#contribution-frequency").val(temScenario1.contributionFrequency);

                $("#number-of-years").val(temScenario1.numberYears);
                let portfolioValue = temScenario1.portfolioType;

                if (typeof portfolioValue == "string") {
                    $("#portfolio-type").val(portfolioValue);
                    $("#other-portfolio").val(0);
                    $(".other-portfolio").hide();
                } else {
                    $("#portfolio-type").val("other");
                    $("#other-portfolio").val(portfolioValue);
                    $(".other-portfolio").show();
                }

                $("#annual-increase-percent").val(temScenario1.annualIncreasePercent);
                $("#annual-increase-dollar").val(temScenario1.annualIncreaseDollar);
                $("[name=annualIncreaseType]").val([temScenario1.annualIncreaseType]);
                if (temScenario1.annualIncreaseType === "percent") {
                    $("#annual-increase-percent").prop("disabled", false);
                    $("#annual-increase-dollar").prop("disabled", true);
                    $(".percentage-input-increase").show();
                    $(".dollar-input-increase").hide();
                }
                if (temScenario1.annualIncreaseType === "dollar") {
                    $("#annual-increase-percent").prop("disabled", true);
                    $("#annual-increase-dollar").prop("disabled", false);
                    $(".percentage-input-increase").hide();
                    $(".dollar-input-increase").show();
                }
            }
        } else {
            // focus on the first input with a validation error
            if ($('[data-error="starting-amount"]').is(":visible")) {
                $("#starting-amount").trigger("focus");
            } else if ($('[data-error="contribution-amount"]').is(":visible")) {
                $("#contribution-amount").trigger("focus");
            } else if ($('[data-error="number-of-years"]').is(":visible")) {
                $("#number-of-years").trigger("focus");
            } else if ($('[data-error="other-portfolio"]').is(":visible")) {
                $("#other-portfolio").trigger("focus");
            } else if ($('[data-error="annual-increase-percent"]').is(":visible")) {
                $("#annual-increase-percent").trigger("focus");
            } else if ($('[data-error="annual-increase-dollar"]').is(":visible")) {
                $("#annual-increase-dollar").trigger("focus");
            }
        }
    });

    $("#scenario-two").on("click", function () {
        if (validation()) {
            $("#scenario-one").attr("aria-selected", false);
            $("#scenario-two").attr("aria-selected", true);
            $("#remove-scenario").trigger("focus");
            $(".pac-container .err-msg").hide();
            $(".pac-container .err-msg").removeAttr("aria-invalid");
            if ($("#scenario-one").hasClass("selected")) {
                temScenario1 = getInputValues();

                $("#scenario-two").addClass("selected");
                $("#scenario-one").removeClass("selected");

                $("#starting-amount").val(formatter.formatNumber(temScenario2.startingAmount));
                $("#contribution-amount").val(formatter.formatNumber(temScenario2.contributionAmount));
                $("#contribution-frequency").val(temScenario2.contributionFrequency);

                $("#number-of-years").val(temScenario2.numberYears);
                let portfolioValue = temScenario2.portfolioType;
                if (typeof portfolioValue == "string") {
                    $("#portfolio-type").val(portfolioValue);
                    $("#other-portfolio").val(0);
                    $(".other-portfolio").hide();
                } else {
                    $("#portfolio-type").val("other");
                    $("#other-portfolio").val(portfolioValue);
                    $(".other-portfolio").show();
                }
                $("#annual-increase-percent").val(temScenario2.annualIncreasePercent);
                $("#annual-increase-dollar").val(temScenario2.annualIncreaseDollar);
                $("[name=annualIncreaseType]").val([temScenario2.annualIncreaseType]);
                if (temScenario2.annualIncreaseType === "percent") {
                    $("#annual-increase-percent").prop("disabled", false);
                    $("#annual-increase-dollar").prop("disabled", true);
                    $(".percentage-input-increase").show();
                    $(".dollar-input-increase").hide();
                }
                if (temScenario2.annualIncreaseType === "dollar") {
                    $("#annual-increase-percent").prop("disabled", true);
                    $("#annual-increase-dollar").prop("disabled", false);
                    $(".percentage-input-increase").hide();
                    $(".dollar-input-increase").show();
                }
            }
        } else {
            // focus on the first input with a validation error
            if ($('[data-error="starting-amount"]').is(":visible")) {
                $("#starting-amount").trigger("focus");
            } else if ($('[data-error="contribution-amount"]').is(":visible")) {
                $("#contribution-amount").trigger("focus");
            } else if ($('[data-error="number-of-years"]').is(":visible")) {
                $("#number-of-years").trigger("focus");
            } else if ($('[data-error="other-portfolio"]').is(":visible")) {
                $("#other-portfolio").trigger("focus");
            } else if ($('[data-error="annual-increase-percent"]').is(":visible")) {
                $("#annual-increase-percent").trigger("focus");
            } else if ($('[data-error="annual-increase-dollar"]').is(":visible")) {
                $("#annual-increase-dollar").trigger("focus");
            }
        }
    });

    $("#remove-scenario").on("click", function () {
        $("#scenario-one").trigger("focus");
        $(".pac-container .err-msg").hide();
        $(".pac-container .err-msg").removeAttr("aria-invalid");

        scenario2 = null;
        temScenario2 = null;
        tempScenario2 = null;
        validity2 = true;
        $("#scenarios-text").css({
            display: "none"
        });
        $("#scenario-one").addClass("selected");
        $("#scenario-one").attr("aria-selected", true);
        $("#scenario-two").addClass("hide");
        $("#scenario-two").attr("aria-selected", false);
        $("#add-scenario").removeClass("hide");
        $("#remove-scenario").addClass("hide");
        $(".scenarios-text").css("display", "none");
        $("#starting-amount").val(tempScenario1.startingAmount);
        $("#contribution-amount").val(tempScenario1.contributionAmount);
        $("#contribution-frequency").val(tempScenario1.contributionFrequency);
        $("#number-of-years").val(tempScenario1.numberYears);

        let portfolioValue = temScenario1.portfolioType;

        if (typeof portfolioValue == "string") {
            $("#portfolio-type").val(portfolioValue);
            $("#other-portfolio").val(0);
            $(".other-portfolio").hide();
        } else {
            $("#portfolio-type").val("other");
            $("#other-portfolio").val(portfolioValue);
            $(".other-portfolio").show();
        }

        $("#annual-increase-percent").val(tempScenario1.annualIncreasePercent);
        $("#annual-increase-dollar").val(tempScenario1.annualIncreaseDollar);
        $("[name=annualIncreaseType]").val([tempScenario1.annualIncreaseType]);
        if (tempScenario1.annualIncreaseType === "percent") {
            $("#annual-increase-percent").prop("disabled", false);
            $("#annual-increase-dollar").prop("disabled", true);
            $(".percentage-input-increase").show();
            $(".dollar-input-increase").hide();
        }
        if (tempScenario1.annualIncreaseType === "dollar") {
            $("#annual-increase-percent").prop("disabled", true);
            $("#annual-increase-dollar").prop("disabled", false);
            $(".percentage-input-increase").hide();
            $(".dollar-input-increase").show();
        }

        $(".scenarios-cashflow").css({ display: "none" });

        if (typeof scenario1InterestRateCashflow == "string") {
            $("#portfolio-type-cashflow").val(scenario1InterestRateCashflow);
            $(".other-portfolio-cashflow").hide();
        }

        if (typeof scenario1InterestRateCashflow == "number") {
            $("#portfolio-type-cashflow").val("other");
            $(".other-portfolio-cashflow").show();
            $("#other-portfolio-cashflow").val(scenario1InterestRateCashflow.toString());
        }

        if (!$(".pac-hint-text").is(":visible")) {
            drawGraphs();
        }

        if (validation()) {
            $(".btn-pac").removeAttr("disabled");
            $(".pdf-pac").removeAttr("disabled");
        } else {
            if (scenario1.contributionAmount === 0 && scenario1.numberYears === 0) {
                $(".pac-container .err-msg").hide();
                $(".pac-container .err-msg").removeAttr("aria-invalid");
            }
        }
    });
}

function updatePrintValues() {
    drawAmount = true;
    const savedParent = retirementGraphImage[0].parentElement;
    document.getElementById("cash-flow-graph-print-container").appendChild(retirementGraphImage[0]);
    retirementCashFlowGraph.options.isPrint = true;
    drawGraphs();
    retirementCashFlowGraph.options.isPrint = false;
    savedParent.appendChild(retirementGraphImage[0]);
    $("[data-popup-box='popup1']").hide();
    setTimeout(() => {
        $("#CashflowYes").prop("checked", false);
        $("#CashflowNo").prop("checked", false);
        $("#print-pac-report").attr("aria-disabled", "true");
    }, 0);
    let contributionfrequencyText1 = $(
        `#contribution-frequency option[value=${scenario1.contributionFrequency}]`
    ).text();
    let interestRateText1 =
        typeof scenario1.portfolioType == "string"
            ? $(`#portfolio-type option[value="${scenario1.portfolioType}"]`).text()
            : formatter.formatPercentage(scenario1.portfolioType);
    let selectedScenario;
    let cashFlowGraph;
    if (showCashFlowReport == true) {
        selectedScenario = $('input[name="scenarios"]:checked').val();
        if (selectedScenario == "scenario1") cashFlowGraph = lastResults.withdrawals;
        else cashFlowGraph = lastResults2.withdrawals;
    }

    let printScenario1 = {
        startingAmount: scenario1.startingAmount,
        contributionAmount: scenario1.contributionAmount,
        contributionFrequency: contributionfrequencyText1,
        numberYears: scenario1.numberYears,
        interestRate: interestRateText1,
        annualIncrease:
            scenario1.annualIncreaseType == "percent"
                ? formatter.formatPercentage(scenario1.annualIncreasePercent)
                : formatter.formatCurrency(scenario1.annualIncreaseDollar)
    };

    let printScenario2 = undefined;
    if (scenario2) {
        let contributionfrequencyText2 = $(
            `#contribution-frequency option[value=${scenario2.contributionFrequency}]`
        ).text();
        let interestRateText2 =
            typeof scenario2.portfolioType == "string"
                ? $(`#portfolio-type option[value="${scenario2.portfolioType}"]`).text()
                : formatter.formatPercentage(scenario2.portfolioType);
        printScenario2 = {
            startingAmount: scenario2.startingAmount,
            contributionAmount: scenario2.contributionAmount,
            contributionFrequency: contributionfrequencyText2,
            numberYears: scenario2.numberYears,
            interestRate: interestRateText2,
            annualIncrease:
                scenario2.annualIncreaseType == "percent"
                    ? formatter.formatPercentage(scenario2.annualIncreasePercent)
                    : formatter.formatCurrency(scenario2.annualIncreaseDollar)
        };
    }

    let selectedScenarioENFR;
    if (selectedScenario === "scenario1") {
        lang === "en" ? (selectedScenarioENFR = "Scenario one") : (selectedScenarioENFR = "Premier scénario");
    } else {
        lang === "en" ? (selectedScenarioENFR = "Scenario two") : (selectedScenarioENFR = "Deuxième scénario");
    }

    let rateOfReturnInRetirement = $("#portfolio-type-cashflow").val();
    rateOfReturnInRetirement =
        rateOfReturnInRetirement === "other"
            ? formatter.formatPercentage($("#other-portfolio-cashflow").val())
            : $(`#portfolio-type-cashflow option[value=${$("#portfolio-type-cashflow").val()}]`).text();

    let printResults = {
        scenario1: printScenario1,
        scenario2: printScenario2,
        cashFlowGraph: cashFlowGraph,
        selectedScenario: selectedScenarioENFR,
        scenario1CashFlowCustomRate: scenario1InterestRateCashflow,
        scenario2CashFlowCustomRate: scenario2InterestRateCashflow,
        rateOfReturnInRetirement,
        graphImage1: pacGraphImage1.get(0).toDataURL(),
        graphImage2: pacGraphImage2.get(0).toDataURL(),
        graphRetirement: retirementGraphImage.get(0).toDataURL()
    };

    storePrintValues(printResults);
    drawAmount = false;
    drawGraphs();
}

function updatePdfValues() {
    updatePrintValues();
    const storedInputs = retrieveFromStorage("pac");
    const format = lang === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";
    const date = formatter.formatDate(new Date(), format);

    $(".pdf-pac-date").text(date);

    // update scenario1 values
    $(".pdf-pac-scenario1-starting-amount").each(function(index) {
        $(this).text(formatter.formatCurrency(storedInputs.scenario1.startingAmount));
    });
    $(".pdf-pac-scenario1-contribution-amount").each(function(index) {
        $(this).text(
            formatter.formatCurrency(storedInputs.scenario1.contributionAmount));
    });
    $(".pdf-pac-scenario1-contribution-frequency").each(function(index) {
        $(this).text(storedInputs.scenario1.contributionFrequency);
    });
    $(".pdf-pac-scenario1-number-of-years").each(function(index) {
        $(this).text(storedInputs.scenario1.numberYears);
    });
    $(".pdf-pac-scenario1-interest-rate").each(function(index) {
        $(this).text(storedInputs.scenario1.interestRate);
    });
    $(".pdf-pac-scenario1-annual-increase").each(function(index) {
        $(this).text(storedInputs.scenario1.annualIncrease);
    });

    // update scenario 2 values if available
    if (!storedInputs.scenario2) {
        $("#pdf-pac-scenario-2").hide();
        $("#scenario-columns").attr("columns", "100%");
        $("#graph-columns").attr("columns", "100%");
        $("#first-print-line").css("width", "100%");
        // $("#graphs-scenario1 > .pac-graph-one").attr("src", storedInputs.graphImage1);
        $("#pdf-pac-graph-src-1").attr("src", storedInputs.graphImage1);
        $("#pdf-pac-graph-src-1").attr("alt", getGraphAltText(results, 1));
        $("#graphs-scenario2").hide();
        $("#graphs-scenario2").removeClass("graph");
        $("#graphs-scenario1").show();
    } else {
        $("#pdf-pac-scenario-2").show();
        $("#scenario-columns").attr("columns", "45% 10% 45%");
        $("#graph-columns").attr("columns", "45% 10% 45%");

        $(".pdf-pac-scenario2-starting-amount").each(function(index) {
            $(this).text(formatter.formatCurrency(storedInputs.scenario2.startingAmount));
        });
        $(".pdf-pac-scenario2-contribution-amount").each(function(index) {
            $(this).text(
                formatter.formatCurrency(storedInputs.scenario2.contributionAmount));
        });
        $(".pdf-pac-scenario2-contribution-frequency").each(function(index) {
            $(this).text(storedInputs.scenario2.contributionFrequency);
        });
        $(".pdf-pac-scenario2-number-of-years").each(function(index) {
            $(this).text(storedInputs.scenario2.numberYears);
        });
        $(".pdf-pac-scenario2-interest-rate").each(function(index) {
            $(this).text(storedInputs.scenario2.interestRate);
        });
        $(".pdf-pac-scenario2-annual-increase").each(function(index) {
            $(this).text(storedInputs.scenario2.annualIncrease);
        });
        
        $("#pdf-pac-graph-src-1").attr("src", storedInputs.graphImage1);
        $("#pdf-pac-graph-src-1").attr("alt", getGraphAltText(results, 1));
        $("#pdf-pac-graph-src-2").attr("src", storedInputs.graphImage2);
        $("#pdf-pac-graph-src-2").attr("alt", getGraphAltText(results2, 2));
        $("#graphs-scenario2").show();
        $("#graphs-scenario2").addClass("graph");
        $("#graphs-scenario1").show();
    }

    if (storedInputs.cashFlowGraph) {
        // update Monthly Cash Flow Retirement values
        const cfg = storedInputs.cashFlowGraph;
        // update header
        if (storedInputs.selectedScenario === "Scenario one" || storedInputs.selectedScenario === "Premier scénario") {
            lang === "en"
                ? $("#pdf-pac-cash-flow-scenario").text("Scenario one")
                : $("#pdf-pac-cash-flow-scenario").text("Premier scénario");
        } else {
            lang === "en"
                ? $("#pdf-pac-cash-flow-scenario").text("Scenario two")
                : $("#pdf-pac-cash-flow-scenario").text("Deuxième scénario");
        }

        // 10 years
        $(".pdf-pac-cash-flow-graph-no-pac-10-years").each(function(index) {
            $(this).text(formatter.formatCurrency(cfg.noPAC["10years"]));
        });
        $(".pdf-pac-cash-flow-graph-no-annual-increase-10-years").each(function(index) {
            $(this).text(formatter.formatCurrency(cfg.noAnnualIncrease["10years"]));
        });
        $(".pdf-pac-cash-flow-graph-pac-10-years").each(function(index) {
            $(this).text(formatter.formatCurrency(cfg.pac["10years"]));
        });

        // 20 years
        $(".pdf-pac-cash-flow-graph-no-pac-20-years").each(function(index) {
            $(this).text(formatter.formatCurrency(cfg.noPAC["20years"]));
        });
        $(".pdf-pac-cash-flow-graph-no-annual-increase-20-years").each(function(index) {
            $(this).text(formatter.formatCurrency(cfg.noAnnualIncrease["20years"]));
        });
        $(".pdf-pac-cash-flow-graph-pac-20-years").each(function(index) {
            $(this).text(formatter.formatCurrency(cfg.pac["20years"]));
        });

        // 30 years
        $(".pdf-pac-cash-flow-graph-no-pac-30-years").each(function(index) {
            $(this).text(formatter.formatCurrency(cfg.noPAC["30years"]));
        });
        $(".pdf-pac-cash-flow-graph-no-annual-increase-30-years").each(function(index) {
            $(this).text(formatter.formatCurrency(cfg.noAnnualIncrease["30years"]));
        });
        $(".pdf-pac-cash-flow-graph-pac-30-years").each(function(index) {
            $(this).text(formatter.formatCurrency(cfg.pac["30years"]));
        });

        // rate of return/custom rate
        if (
            $("#portfolio-type-cashflow > option:selected").val() === "other" ||
            $("#portfolio-type-cashflow > option:selected").val() === "autre"
        ) {
            $("#cash-flow-ror").text(`${$("#other-portfolio-cashflow").val()}%`);
        } else {
            $("#cash-flow-ror").text($("#portfolio-type-cashflow > option:selected").text());
        }

        // graph
        $("#pdf-pac-cash-flow-graph-retirement").attr("src", storedInputs.graphRetirement);

        // legend and lines
        if ($("#ScenarioTwo").is(":checked")) {
            $(".cash-flow-print-line").attr("src", "./common/images/print/blue-line.png");
            $(".cash-flow-print-line").attr("alt", "blue line");
            $("#cash-flow-print-legend").attr("src", "./common/images/pdf/current.png");
            $("#cash-flow-print-legend").attr("alt", "dark blue legend");
            $(".cash-flow-print-legend-mid").attr("src", "./common/images/pdf/current-pac.png");
            $(".cash-flow-print-legend-mid").attr("alt", "green legend");
            $(".cash-flow-print-legend-light").attr("src", "./common/images/pdf/current-pac-increase.png");
            $(".cash-flow-print-legend-light").attr("alt", "light blue legend");
        } else {
            $(".cash-flow-print-line").attr("src", "./common/images/print/green-line.png");
            $(".cash-flow-print-line").attr("alt", "green line");
            $("#cash-flow-print-legend").attr("src", "./common/images/pdf/current.png");
            $("#cash-flow-print-legend").attr("alt", "dark blue legend");
            $(".cash-flow-print-legend-mid").attr("src", "./common/images/pdf/current-pac.png");
            $(".cash-flow-print-legend-mid").attr("alt", "green legend");
            $(".cash-flow-print-legend-light").attr("src", "./common/images/pdf/current-pac-increase.png");
            $(".cash-flow-print-legend-light").attr("alt", "light blue legend");
        }

        $("#pdf-report .bottom .page p")
            .eq(0)
            .text(lang === "en" ? "Page 1 of 2" : "Page 1 de 2");
        $("#pdf-report").find("pdf-page").eq(1).show();
    } else {
        $("#pdf-report .bottom .page p")
            .eq(0)
            .text(lang === "en" ? "Page 1 of 1" : "Page 1 de 1");
        $("#pdf-report").find("pdf-page").eq(1).hide();
    }
}

function getGraphAltText(result, scenario) {
    const savings = result.savings;
    return lang === "en" ? 
        `Scenario ${scenario} graph. In ${savings.years} years. 
        Current savings: ${formatter.formatCurrency(savings.noPAC.retirement)}.
        Current savings + PAC: ${formatter.formatCurrency(savings.noAnnualIncrease.retirement)}.
        Current savings + PAC + increase: ${formatter.formatCurrency(savings.pac.retirement)}.`
        :
        `Graphe ${scenario === 1 ? "premier scénario" : "ajouter scénario"}. Dans ${savings.years} ans. 
        Épargne actuelle : ${formatter.formatCurrency(savings.noPAC.retirement)}.
        Épargne actuelle + PAC : ${formatter.formatCurrency(savings.noAnnualIncrease.retirement)}.
        Épargne actuelle + PAC + augmentation : ${formatter.formatCurrency(savings.pac.retirement)}.`;
}

let clientWidth = document.documentElement.clientWidth;
function setUpGraphResizing() {
    $(window).on("resize", () => {
        if (document.documentElement.clientWidth === clientWidth) {
            return false;
        }

        clientWidth = document.documentElement.clientWidth;
        if (!$(".cashflow-row .accordion").hasClass("disabled")) {
            drawGraphs();

            if ($(".scenarios-text").is(":visible")) {
                if (document.documentElement.clientWidth < 768) {
                    $(".scenarios-text-wide").css({
                        display: "none"
                    });
                    $(".scenarios-text-narrow").css({
                        display: "block"
                    });
                } else {
                    $(".scenarios-text-narrow").css({
                        display: "none"
                    });
                    $(".scenarios-text-wide").css({
                        display: "flex"
                    });
                }
            }
        }
    });
}

const videoNumericInputs = $(".pac-video .numeric");
function setUpVideoFields() {
    $(".rm-slider-handle").attr("aria-label", "video progress bar");
    videoNumericInputs.on("keyup", ({ target }) => {
        const input = $(target);

        input.val(input.val().replace(/\D/g, ""));
    });
}

var lastFocusElement = undefined;

$( document ).ready(function() {
    $(".modalopener").click(function(){
        var $this = $(this);
        var parentElement = document.getElementById($this.data("target").replace("#",""));
        modalTrap(parentElement);
        lastFocusElement = $(this);
    });
});

var firstFocusableElement;
var lastFocusableElement;

const firstFocusableElementListener = function KeyDownListenerFirst (e) {
    if (e.keyCode === 9 && e.shiftKey) {
        lastFocusableElement.focus();
        e.preventDefault();
    }
}

const lastFocusableElementListener = function KeyDownListenerLast(e) {
    let evt =  window.event;
    if (evt.keyCode === 9 && !evt.shiftKey) {
        firstFocusableElement.focus();
        evt.preventDefault();
    }
}

function modalTrap(activeModal) {
    if (!activeModal) return false;
    let parentPage = document.getElementById('page');
    if (parentPage){
        parentPage.classList.add('blur');
        parentPage.setAttribute("aria-hidden", "true");
    }
    var activeElements = activeModal.querySelectorAll('button, select:not([disabled]), [tabindex="0"], a, input');
    firstFocusableElement = activeElements[0];
    lastFocusableElement = activeElements[activeElements.length - 1];  
    firstFocusableElement.focus();       
    firstFocusableElement.addEventListener('keydown', firstFocusableElementListener);
    lastFocusableElement.addEventListener('keydown', lastFocusableElementListener);
}

$(() => {
    try {
        if (window.location.search === "?pdf") {
            setupPreview();
            return;
        }
        if (window.location.search === "?pdf-video") {
            setupPreview(document.getElementById("pdf-report-video"));
            return;
        }

        // reset form input values on IE browser refresh
        $("#pac-input-values").trigger("reset");
        $("#cash-flow-retirement-form").trigger("reset");

        setUpNumericInputs();
        fillFieldsOnBlur();
        setupRealTimeErrorChecking();
        setInputMaxLengths();
        restrictInputs();
        setUpPopups();
        setUpCustomRateVisiblity();
        setUpAnnualPACIncreaseVisibility();
        setUpButtons();
        setUpWatchVideoButton();
        setUpCheckboxes();
        setUpRetirementCashFlowAccordion();
        setUpGraphResizing();
        addRemoveScenario();
        setUpVideoFields();

        $("#load-bold").hide();
        $(".err-msg").hide();

        $(".pac-container")
            .find("input, select")
            .on("change keyup focusout", (event) => {
                let validation1 = false;
                let validation2 = false;
                const eventType = event.type;
                const targetID = event.target.id;
                if ($("#scenario-two").is(":visible")) {
                    if ($("#scenario-one").hasClass("selected")) {
                        tempScenario1 = getInputValues();
                        validation1 = validation(eventType, targetID);
                        if (tempScenario1.contributionAmount >= 25 && tempScenario1.numberYears >= 1 && validation1) {
                            validity1 = true;
                        } else {
                            validity1 = false;
                        }
                    }

                    if ($("#scenario-two").hasClass("selected")) {
                        tempScenario2 = getInputValues();
                        validation2 = validation(eventType, targetID);
                        if (tempScenario2.contributionAmount >= 25 && tempScenario2.numberYears >= 1 && validation2) {
                            validity2 = true;
                        } else {
                            validity2 = false;
                        }
                    }

                    if (validity1 && validity2) {
                        $(".btn-pac").removeAttr("disabled");
                    }
                } else {
                    tempScenario1 = getInputValues();
                    validation1 = validation(eventType, targetID);
                    if (tempScenario1.contributionAmount >= 25 && tempScenario1.numberYears >= 1 && validation1) {
                        validity1 = true;
                        $(".btn-pac").removeAttr("disabled");
                    } else {
                        validity1 = false;
                    }
                }
            });

        $("#cash-flow-retirement-form").on("change", () => {
            checkboxChange = true;
            drawGraphs(true);
            checkboxChange = false;
        });

        $(".pac-video")
            .find("input")
            .on("change keyup focusout", () => {
                // value length before formatting
                $("#starting-amount-video").attr("maxlength", "6");
                $("#contribution-amount-video").attr("maxlength", "5");

                const values = getVideoInputValues();
                if (
                    values.name !== "" &&
                    values.startingAmount >= 0 &&
                    values.contributionAmount >= 1 &&
                    values.contributionIncrease >= 0 &&
                    videoInputsValidation()
                ) {
                    $(".btn-watch-vid").removeAttr("disabled");
                    $(".play-btn-small").removeAttr("disabled");
                }
            });

        $('input[name="printReport"]').on("change", function () {
            $("#print-pac-report").removeAttr("aria-disabled");
            const inputValue = $("input[name='printReport']:checked").val();
            if (inputValue == "yes") {
                showCashFlowReport = true;
            } else {
                showCashFlowReport = false;
            }
        });

        $("#print-pac-report").on("click", function (event) {
            if ($(this).attr("aria-disabled") === "true") {
                event.preventDefault();
            } else {
                const buttonLabel = $(this).text();
                    if (buttonLabel === "Download Report" || buttonLabel === "Télécharger le rapport") {
                        updatePdfValues();
                        generatePDF();
                    } else {
                        window.open("print/pac.html");
                    }
            }
        });

        $("main .container h2:first").focus();

        $("[data-popup-click]").on("click", function () {
            const popupHeaders = {
                download: {
                    en: "Download Report",
                    fr: "Télécharger le rapport"
                },
                print: {
                    en: "Print Report",
                    fr: "Imprimer le rapport"
                }
            };
            const popupID = $(this).attr("data-popup-click");
            const popup = $(`[data-popup-box='${popupID}']`);
            const buttonID = $(this).attr("id");
            const popupHeader = buttonID === "pdf-btn" ? popupHeaders.download[lang] : popupHeaders.print[lang];
            popup.find("button#print-pac-report, h2").text(popupHeader);
            popup.show().focus();
        });

        $("[data-popup-box]").on("click", function (e) {
            if (
                $(e.target).attr("class") &&
                ($(e.target).attr("class").indexOf("popup_inner") > -1 ||
                    $(e.target).attr("class").indexOf("close_btn") > -1)
            ) {
                var id = $(this).closest("[data-popup-box]").attr("data-popup-box");
                $("[data-popup-box]").hide();
                const buttonLabel = $(this).text();
                setTimeout(() => {
                    if (buttonLabel.includes("Download Report") || buttonLabel.includes("Télécharger le rapport")) {
                        $("#pdf-btn").focus();
                    } else {
                        $("#print-btn").focus();
                    }
                }, 0);
            }
            if ($(e.target).attr("class") && $(e.target).attr("class").indexOf("close_btn") > -1) {
                $("#CashflowYes").prop("checked", false);
                $("#CashflowNo").prop("checked", false);
                $("#print-pac-report").attr("aria-disabled", "true");
            }
        });
    } catch (error) {
        console.log(error);
    }
});

$("#pgNavTaggle").on("click", () => {
    $(".fa-chevron-up").css("display", "");
});

export { updateRetirementCheckboxes, pacStorage };
